export interface MarketingLeadRecord {
  id: string
  eventKey: string
  eventName: string
  sourceFile: string
  fullName: string
  email: string
  company: string
  role: string
  phone: string
  city: string
  state: string
  country: string
  postalCode: string
  ticketType: string
  context: string
  notes: string
  scannedAt: string
}

export const marketingLeads2026: MarketingLeadRecord[] = [
  {
    id: 'vmx-2026-1',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'JUSTINE GROOMBRIDGE',
    email: 'JUSTINE@HOTSTREETFARM.COM',
    company: 'N/A',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:06:04 EST',
  },
  {
    id: 'vmx-2026-2',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Dave Groombridge',
    email: 'dave.groombridge@pioneervet.co.uk',
    company: 'Pioneer Veterinary Products',
    role: 'Director',
    phone: '',
    city: 'Canterbury',
    state: 'KEN',
    country: 'GB',
    postalCode: 'CT4 6SG',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:06:17 EST',
  },
  {
    id: 'vmx-2026-3',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Cindy Hooper',
    email: 'thevetforyourpets@gmail.com',
    company: 'Halo At Home',
    role: 'Owner/Veterinarian',
    phone: '',
    city: 'Aurora',
    state: 'IL',
    country: 'US',
    postalCode: '60504',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:14:55 EST',
  },
  {
    id: 'vmx-2026-4',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kelly Clements',
    email: 'kclem1966@gmail.com',
    company: 'N/A',
    role: 'Veterinarian',
    phone: '',
    city: 'Arvada',
    state: 'CO',
    country: 'US',
    postalCode: '80007',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:15:06 EST',
  },
  {
    id: 'vmx-2026-5',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Emily Lewallen',
    email: 'elewallen6@gmail.com',
    company: 'Missions Pet Health - Clarkesville Veterinary Hospital',
    role: 'Vet Assistant',
    phone: '',
    city: 'Clarkesville',
    state: 'GA',
    country: 'US',
    postalCode: '30523',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:18:13 EST',
  },
  {
    id: 'vmx-2026-6',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Emily Satterfield',
    email: 'e.satterfield33@gmail.com',
    company: 'Missions Pet Health - Clarkesville Veterinary Hospital',
    role: 'Vet Assistant',
    phone: '',
    city: 'Clarkesville',
    state: 'GA',
    country: 'US',
    postalCode: '30523',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:18:16 EST',
  },
  {
    id: 'vmx-2026-7',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Mantey Alexander',
    email: 'amanu5@yahoo.com',
    company: 'Animal Care Center of Downers Grove',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Naperville',
    state: 'IL',
    country: 'US',
    postalCode: '60563',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:20:41 EST',
  },
  {
    id: 'vmx-2026-8',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Mackenzie Greene',
    email: 'm.greene@metropolitanvet.com',
    company: 'Metropolitan Veterinary Hospital- Cleveland East',
    role: 'Ophthalmology Supervisor',
    phone: '',
    city: 'Norton',
    state: 'OH',
    country: 'United States',
    postalCode: '44203',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:25:04 EST',
  },
  {
    id: 'vmx-2026-9',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kitra Wake',
    email: 'kitracasteel77@gmail.com',
    company: 'Metropolitan Veterinary Hosptial',
    role: 'RVT/Shiftlead',
    phone: '',
    city: 'Norton',
    state: 'OH',
    country: 'US',
    postalCode: '44203',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:25:08 EST',
  },
  {
    id: 'vmx-2026-10',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Michael Ogden-Schuette',
    email: 'mikeos.dvm@gmail.com',
    company: 'Lap of Love',
    role: '',
    phone: '',
    city: 'Addison',
    state: 'IL',
    country: 'US',
    postalCode: '60101',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:27:56 EST',
  },
  {
    id: 'vmx-2026-11',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Valorie Bennett',
    email: 'valorie@halifaxvetcenter.com',
    company: 'Halifax Veterinary Center',
    role: 'Inventory Manager',
    phone: '',
    city: 'Port Orange',
    state: 'FL',
    country: 'US',
    postalCode: '32127',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:28:50 EST',
  },
  {
    id: 'vmx-2026-12',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sue Bennett',
    email: 'sue@halifaxvetcenter.com',
    company: 'Halifax Veterinary Center',
    role: 'Hospital Manager',
    phone: '',
    city: 'Port Orange',
    state: 'FL',
    country: 'US',
    postalCode: '32127',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:28:54 EST',
  },
  {
    id: 'vmx-2026-13',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sam BARSCZ',
    email: 'SBARSCZ13@YAHOO.COM',
    company: 'RELIEF',
    role: 'Veterinarian',
    phone: '',
    city: 'Northford',
    state: 'CT',
    country: 'US',
    postalCode: '06472',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:35:37 EST',
  },
  {
    id: 'vmx-2026-14',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Patricia Turmenne',
    email: 'dr.turmenne.dvm@gmail.com',
    company: 'Pet Shield Veterinary Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Northford',
    state: 'CT',
    country: 'US',
    postalCode: '06472',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:35:40 EST',
  },
  {
    id: 'vmx-2026-15',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Samantha Ruzicka',
    email: 'sam.ruzicka@gmail.com',
    company: 'Animal House Veterinary Clinic',
    role: 'Veterinary Technician',
    phone: '',
    city: 'Clarksville',
    state: 'TN',
    country: 'US',
    postalCode: '37040',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:35:48 EST',
  },
  {
    id: 'vmx-2026-16',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Autumn Woodward',
    email: 'autumn.woodward@hotmail.com',
    company: 'Daleville Animal Hospital',
    role: '',
    phone: '',
    city: 'ENTERPRISE',
    state: 'AL',
    country: 'US',
    postalCode: '36330',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:35:50 EST',
  },
  {
    id: 'vmx-2026-17',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sarah Squier',
    email: 'mrsdocsilly73@gmail.com',
    company: 'Easy Vet Magnolia',
    role: 'Technician',
    phone: '',
    city: 'Webster',
    state: 'FL',
    country: 'US',
    postalCode: '33597',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:41:11 EST',
  },
  {
    id: 'vmx-2026-18',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'MICHAEL SQUIER',
    email: '',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: 'US',
    postalCode: '',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:41:17 EST',
  },
  {
    id: 'vmx-2026-19',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'jayla huntley',
    email: 'jayla.huntley@icloud.com',
    company: 'fixing the boro',
    role: 'Veterinary assistant',
    phone: '',
    city: 'Dudley',
    state: 'GA',
    country: 'US',
    postalCode: '31022',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:46:01 EST',
  },
  {
    id: 'vmx-2026-20',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jayla Ellison-Wilkes',
    email: 'jaylawilkes2@gmail.com',
    company: 'Florida Agricultural and Mechanical University',
    role: 'Student',
    phone: '',
    city: 'Tallahassee',
    state: 'FL',
    country: 'US',
    postalCode: '32304',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:48:27 EST',
  },
  {
    id: 'vmx-2026-21',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jayla Ellison-Wilkes',
    email: 'jaylawilkes2@gmail.com',
    company: 'Florida Agricultural and Mechanical University',
    role: 'Student',
    phone: '',
    city: 'Tallahassee',
    state: 'FL',
    country: 'US',
    postalCode: '32304',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:48:27 EST',
  },
  {
    id: 'vmx-2026-22',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Arielle Burrows',
    email: 'aburrows1075@gmail.com',
    company: 'n/a',
    role: '',
    phone: '',
    city: 'white plains',
    state: 'NY',
    country: 'US',
    postalCode: '10601',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:48:31 EST',
  },
  {
    id: 'vmx-2026-23',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Andrew Craft',
    email: 'acraft.vet@gmail.com',
    company: 'Heart + Paw Greensburg',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Jeannette',
    state: 'PA',
    country: 'US',
    postalCode: '15644',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:51:38 EST',
  },
  {
    id: 'vmx-2026-24',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jennifer Adam',
    email: 'jenniferlisa.adam@gmail.com',
    company: 'Green Acres Veterinary Center',
    role: '',
    phone: '',
    city: 'Grand Island',
    state: 'NY',
    country: 'US',
    postalCode: '14072',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 13:55:56 EST',
  },
  {
    id: 'vmx-2026-25',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Ann-McCullough Cook',
    email: 'annc@edcet.com',
    company: 'Edcetera/VetPrep',
    role: 'Associate Director of Sales & Strategy, Animal Health',
    phone: '',
    city: 'Summerville',
    state: 'SC',
    country: 'US',
    postalCode: '29486',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:00:18 EST',
  },
  {
    id: 'vmx-2026-26',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Cheyenne Jonas',
    email: 'cheyennej@edcet.com',
    company: 'Edcetera',
    role: 'Strategic Account Manager',
    phone: '',
    city: 'Indianapolis',
    state: 'IN',
    country: 'US',
    postalCode: '46217',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:00:21 EST',
  },
  {
    id: 'vmx-2026-27',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Carl Mankiewicz',
    email: 'chiromanx@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: 'Danielsville',
    state: 'GA',
    country: 'US',
    postalCode: '30633',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:01:18 EST, 2026-01-17 14:06:49 EST',
  },
  {
    id: 'vmx-2026-28',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jennifer Howard',
    email: 'jenhoward145@gmail.com',
    company: 'Boulevard Animal Hospital',
    role: '',
    phone: '',
    city: 'Athens',
    state: 'GA',
    country: 'US',
    postalCode: '30601',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:01:21 EST, 2026-01-17 14:06:51 EST',
  },
  {
    id: 'vmx-2026-29',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Joyce Landry',
    email: 'joy_lan@hotmail.com',
    company: '',
    role: '',
    phone: '',
    city: 'Havre Boucher',
    state: 'NS',
    country: 'CA',
    postalCode: 'B0H 1P0',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:02:59 EST',
  },
  {
    id: 'vmx-2026-30',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'William Twyman',
    email: 'williamtwyman@veg.com',
    company: 'VEG',
    role: 'Nursing Manager',
    phone: '',
    city: 'Atlanta',
    state: 'GA',
    country: 'US',
    postalCode: '30349',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:11:55 EST, 2026-01-17 14:12:02 EST',
  },
  {
    id: 'vmx-2026-31',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jada White',
    email: 'jadawhite@veg.com',
    company: 'Veg ER for Pets',
    role: 'Veterinary Assistant',
    phone: '',
    city: 'Snellville',
    state: 'GA',
    country: 'US',
    postalCode: '30039',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:12:08 EST',
  },
  {
    id: 'vmx-2026-32',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Debbie Utz',
    email: 'jetgreydogs@aol.com',
    company: '',
    role: '',
    phone: '',
    city: 'Orlando',
    state: 'FL',
    country: 'US',
    postalCode: '32826',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:13:07 EST',
  },
  {
    id: 'vmx-2026-33',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Janet Leboeuf',
    email: 'huntersmom0305@aol.com',
    company: '',
    role: '',
    phone: '',
    city: 'Cape Coral',
    state: 'FL',
    country: 'US',
    postalCode: '33914',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:13:11 EST',
  },
  {
    id: 'vmx-2026-34',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Cleva Claiborne',
    email: 'cbccbc@hotmail.com',
    company: 'Retired- Animal Medical Center of Greeneville',
    role: 'Practice Manager',
    phone: '',
    city: 'Crossville',
    state: 'TN',
    country: 'US',
    postalCode: '38571',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:14:51 EST',
  },
  {
    id: 'vmx-2026-35',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'John Tuohy',
    email: 'john.tuohy89@gmail.com',
    company: 'Mahoning Valley Veterinary Centre',
    role: 'Floor Manager',
    phone: '',
    city: 'Mineral Ridge',
    state: 'OH',
    country: 'US',
    postalCode: '44440',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:19:48 EST',
  },
  {
    id: 'vmx-2026-36',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Arika Hallisey',
    email: 'arikah2134@gmail.com',
    company: 'Cranberry Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '',
    city: 'Freedom',
    state: 'PA',
    country: 'US',
    postalCode: '15042',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:25:17 EST',
  },
  {
    id: 'vmx-2026-37',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Madison Long',
    email: 'mdsnlng2016@gmail.com',
    company: 'Cranberry Veterinary Hospital',
    role: 'CVT',
    phone: '',
    city: 'Butler',
    state: 'PA',
    country: 'US',
    postalCode: '16002',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:25:20 EST',
  },
  {
    id: 'vmx-2026-38',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Omar Montes',
    email: 'montesdvm@gmail.com',
    company: 'Caring Hearts Animal Clinic',
    role: 'associate veterinarian',
    phone: '',
    city: 'florence',
    state: 'AZ',
    country: 'US',
    postalCode: '85132',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:28:22 EST',
  },
  {
    id: 'vmx-2026-39',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sheneizka Martir Sosa',
    email: 'sheneizkamartir@gmail.com',
    company: 'NVA City Creatures Animal Hospital',
    role: 'LVT',
    phone: '',
    city: 'buffalo',
    state: 'NY',
    country: 'US',
    postalCode: '14216',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:33:15 EST',
  },
  {
    id: 'vmx-2026-40',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Autumn Abel-Sikorski',
    email: 'abelsikorskia@gmail.com',
    company: 'NVA City Creatures Animal Hospital',
    role: 'Licensed Veterinary Technician',
    phone: '',
    city: 'Buffalo',
    state: 'NY',
    country: 'US',
    postalCode: '14206',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:33:17 EST',
  },
  {
    id: 'vmx-2026-41',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Rachel Tollar',
    email: 'rachel.tollar@nva.com',
    company: 'NVA City Creatures Animal Hospital',
    role: 'Hospital Manager',
    phone: '',
    city: 'Buffalo',
    state: 'NY',
    country: 'US',
    postalCode: '14216',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:33:19 EST',
  },
  {
    id: 'vmx-2026-42',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Nathan Ayersman',
    email: 'nathan.ayersman@nva.com',
    company: 'Creature Comforts Veterinary Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'West Norriton',
    state: 'PA',
    country: 'US',
    postalCode: '19403',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:36:03 EST',
  },
  {
    id: 'vmx-2026-43',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Charles St Jean',
    email: 'yorkshirevet@yahoo.com',
    company: 'Yorkshire Veterinary Clinic',
    role: 'Owner/Practioner',
    phone: '7409641112',
    city: 'Sunbury',
    state: 'OH',
    country: 'US',
    postalCode: '43074-7504',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:39:33 EST',
  },
  {
    id: 'vmx-2026-44',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Roberto Perez',
    email: 'r.perez@ctvetcenter.com',
    company: 'Connecticut Veterinary Center',
    role: 'Senior Manager',
    phone: '',
    city: 'West Hartford',
    state: 'CT',
    country: 'US',
    postalCode: '06110',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:42:15 EST',
  },
  {
    id: 'vmx-2026-45',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Lauren Fishman',
    email: 'lrosesteiner@gmail.com',
    company: 'WestChase Veterinary Center & Emergency',
    role: 'Veterinarian',
    phone: '',
    city: 'Tampa',
    state: 'FL',
    country: 'US',
    postalCode: '33626',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:47:16 EST',
  },
  {
    id: 'vmx-2026-46',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jonathan Maddon',
    email: 'jtmaddon@gmail.com',
    company: 'Park Slope Veterinary Care',
    role: 'Veterinary Assistant',
    phone: '',
    city: 'Staten Island',
    state: 'NY',
    country: 'US',
    postalCode: '10314',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:47:53 EST',
  },
  {
    id: 'vmx-2026-47',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Alyssa Seliger',
    email: 'lyssams@aol.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:52:28 EST',
  },
  {
    id: 'vmx-2026-48',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jessica Rich',
    email: 'jessicarich@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:52:31 EST',
  },
  {
    id: 'vmx-2026-49',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jamie McMinn',
    email: 'jamiebeachbound@yahoo.com',
    company: 'nature coast animal wellness',
    role: 'Vet Tech',
    phone: '',
    city: 'Weeki Wachee',
    state: 'FL',
    country: 'US',
    postalCode: '34613',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 14:58:12 EST',
  },
  {
    id: 'vmx-2026-50',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jeffrey Johnson',
    email: 'jeffrey.johnson@blueskyanimal.com',
    company: 'Blue Sky Animal Hospital',
    role: 'Medical Director',
    phone: '',
    city: 'Wyoming',
    state: 'MN',
    country: 'US',
    postalCode: '55092',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:08:05 EST',
  },
  {
    id: 'vmx-2026-51',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kristin Lindblad',
    email: 'kristi.lindblad@blueskyanimal.com',
    company: 'Blue Sky Animal Hospital',
    role: 'Sr. Certified Veterinary Technician',
    phone: '6514627387',
    city: 'Wyoming',
    state: 'MN',
    country: 'US',
    postalCode: '55092',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:08:08 EST',
  },
  {
    id: 'vmx-2026-52',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Ronald Braddock',
    email: 'sherrybraddock48@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: 'zolfo springs',
    state: 'FL',
    country: 'US',
    postalCode: '33890',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:12:30 EST',
  },
  {
    id: 'vmx-2026-53',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Cieonna Johnson',
    email: 'cieonnajohnson@veg.com',
    company: 'VEG - Veterinary Emergency Group',
    role: 'Veterinary Assistant',
    phone: '',
    city: 'Kansas City',
    state: 'MO',
    country: 'US',
    postalCode: '64134',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:16:27 EST',
  },
  {
    id: 'vmx-2026-54',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sammi Martin',
    email: 'sammiclairemartin@gmail.com',
    company: 'Goodvets Overland Park',
    role: '',
    phone: '',
    city: 'Kansas city',
    state: 'KS',
    country: 'US',
    postalCode: '66106',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:16:30 EST',
  },
  {
    id: 'vmx-2026-55',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Linda Schneider',
    email: 'trapbrook@aol.com',
    company: 'Guardian Veterinary Medical Center',
    role: 'veterinarian',
    phone: '',
    city: 'Port St. Lucie',
    state: 'FL',
    country: 'US',
    postalCode: '34986',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:22:55 EST',
  },
  {
    id: 'vmx-2026-56',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Lauren Abbott',
    email: 'labbott@aavsb.org',
    company: 'AAVSB',
    role: 'CE Program Manager',
    phone: '',
    city: 'Overland Park',
    state: 'KS',
    country: 'US',
    postalCode: '66210',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:28:39 EST',
  },
  {
    id: 'vmx-2026-57',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jennifer Wartenbee',
    email: 'wartenbeej@epud.net',
    company: 'Volusia Woods Animal Clinic',
    role: 'Veterinarian',
    phone: '',
    city: 'Sanford',
    state: 'FL',
    country: 'US',
    postalCode: '32771',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:36:55 EST',
  },
  {
    id: 'vmx-2026-58',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Marnie Reimer',
    email: 'mreimer@vt.edu',
    company: 'N/A',
    role: '',
    phone: '',
    city: 'Lanoka Harbor',
    state: 'NJ',
    country: 'US',
    postalCode: '08734',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:37:31 EST',
  },
  {
    id: 'vmx-2026-59',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Donna Smith',
    email: 'finickyfeline426@gmail.com',
    company: 'Carevet Bethel Village Square Animal Hospital',
    role: 'CVT',
    phone: '',
    city: 'Danbury',
    state: 'CT',
    country: 'US',
    postalCode: '06811',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:39:54 EST',
  },
  {
    id: 'vmx-2026-60',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Diaphni Taylhardat',
    email: 'diaphni@gmail.com',
    company: 'Hometown Veterinary Partners',
    role: 'Lead Veterinarian',
    phone: '',
    city: 'Sarasota',
    state: 'FL',
    country: 'US',
    postalCode: '34231',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:46:26 EST',
  },
  {
    id: 'vmx-2026-61',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Elizabeth Crum',
    email: 'elizabethcrum@hometownvetpartners.com',
    company: 'Hometown Veterinary Partners',
    role: 'Practice Manager',
    phone: '',
    city: 'Riverview',
    state: 'FL',
    country: 'US',
    postalCode: '33578',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:46:28 EST',
  },
  {
    id: 'vmx-2026-62',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sarah Kenyon',
    email: 'srkenyon2@yahoo.com',
    company: 'Vetcor/ North Central Animal Hospital',
    role: 'Associate veterinarian',
    phone: '',
    city: 'New River',
    state: 'AZ',
    country: 'US',
    postalCode: '85087',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:52:18 EST',
  },
  {
    id: 'vmx-2026-63',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Katie Trepanier',
    email: 'kntrepanier@gmail.com',
    company: 'Lovet Dobson Ranch',
    role: 'Veterinarian',
    phone: '',
    city: 'Mesa',
    state: 'AZ',
    country: 'US',
    postalCode: '85205',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 15:52:22 EST',
  },
  {
    id: 'vmx-2026-64',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Colton Doll',
    email: 'coltondvm@gmail.com',
    company: 'Kings Trail Animal Hospital',
    role: '',
    phone: '',
    city: 'Jacksonville',
    state: 'FL',
    country: 'US',
    postalCode: '32223',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:03:40 EST',
  },
  {
    id: 'vmx-2026-65',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jill Kirschenbaum',
    email: 'kirschenbaum3@gmail.com',
    company: 'Emergency Animal Hospital of Crystal Falls',
    role: '',
    phone: '',
    city: 'Round Rock',
    state: 'TX',
    country: 'US',
    postalCode: '78665',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:06:08 EST',
  },
  {
    id: 'vmx-2026-66',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Nadav Gigi',
    email: 'nadav.gigi@vetmarket.co.il',
    company: 'Vetmarket',
    role: 'GM',
    phone: '',
    city: 'Shoham',
    state: '',
    country: 'IL',
    postalCode: '6085001',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:10:54 EST',
  },
  {
    id: 'vmx-2026-67',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Autumn McKenzie',
    email: 'imagica2658@yahoo.com',
    company: 'Oakhurst Veterinary Hospital',
    role: 'DVM - Owner',
    phone: '17273919784',
    city: 'Largo',
    state: 'FL',
    country: 'US',
    postalCode: '33773',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:11:01 EST, 2026-01-17 16:15:29 EST',
  },
  {
    id: 'vmx-2026-68',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Cheryl Lagana',
    email: 'laganaavc@yahoo.com',
    company: 'Abington Veterinary Center',
    role: 'Veterinarian',
    phone: '',
    city: 'Drums',
    state: 'PA',
    country: 'US',
    postalCode: '18222',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:11:04 EST',
  },
  {
    id: 'vmx-2026-69',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Megan Lashinski',
    email: 'mbiduckcvt@live.com',
    company: 'Abington Veterinary Center',
    role: 'Certified Veterinary Technician',
    phone: '',
    city: 'South Abington Township',
    state: 'PA',
    country: 'US',
    postalCode: '18411',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:11:08 EST',
  },
  {
    id: 'vmx-2026-70',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kenneth Cox',
    email: 'kencoxdvm@gmail.com',
    company: 'Animal Clinic',
    role: 'Veterinarian',
    phone: '13864246662',
    city: 'Port Orange',
    state: 'FL',
    country: 'US',
    postalCode: '32128',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:11:16 EST',
  },
  {
    id: 'vmx-2026-71',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Michael Giard',
    email: 'michaelgiard@gmail.com',
    company: 'Kindred Spirits Vet Clinic',
    role: 'Associate Veterinarian',
    phone: '2078258989',
    city: 'Orland',
    state: 'ME',
    country: 'US',
    postalCode: '04472',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:22:00 EST',
  },
  {
    id: 'vmx-2026-72',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Luis Egoavil',
    email: 'legoavil@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: 'Pompano Beach',
    state: 'FL',
    country: 'US',
    postalCode: '33069',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:24:26 EST',
  },
  {
    id: 'vmx-2026-73',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Gilles Nespoulous',
    email: 'gilles.nespoulous@ceva.com',
    company: 'Ceva Animal Health',
    role: 'Diagnostic & Digital Innovation Group Manager',
    phone: '',
    city: 'Lenexa',
    state: 'KS',
    country: 'US',
    postalCode: '66215',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:40:29 EST',
  },
  {
    id: 'vmx-2026-74',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'James Hughes',
    email: 'hughespetvet@gmail.com',
    company: 'Hughes All Creatures Animal Clinic',
    role: 'Veterinarian',
    phone: '17277850405',
    city: 'PALM HARBOR',
    state: 'FL',
    country: 'US',
    postalCode: '34685',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:42:25 EST',
  },
  {
    id: 'vmx-2026-75',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kennedy Lambert',
    email: 'kennedy.lambert@hotmail.com',
    company: 'Uxbridge Veterinary Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Newmarket',
    state: 'ON',
    country: 'CA',
    postalCode: 'L3Y5M9',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:58:40 EST',
  },
  {
    id: 'vmx-2026-76',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Amanda Bowen',
    email: 'amandabowen3853@gmail.com',
    company: 'Uxbridge Veterinary Hospital',
    role: 'RVT',
    phone: '',
    city: 'Port Perry',
    state: 'ON',
    country: 'CA',
    postalCode: 'L9L1X6',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 16:58:47 EST',
  },
  {
    id: 'vmx-2026-77',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kiersten Record',
    email: 'kierstenrecord@outlook.com',
    company: 'New Palestine Veterinary Clinic',
    role: '',
    phone: '',
    city: 'Indianapolis',
    state: 'IN',
    country: 'US',
    postalCode: '46237',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:01:07 EST',
  },
  {
    id: 'vmx-2026-78',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Carlos Ameijeiras',
    email: 'ameijeirasdvm@gmail.com',
    company: 'Neighborhood veterinary Center',
    role: '',
    phone: '',
    city: 'Hallandale Beach',
    state: 'FL',
    country: 'US',
    postalCode: '33009',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:06:10 EST',
  },
  {
    id: 'vmx-2026-79',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Douglas Piper',
    email: 'verandahvet@msn.com',
    company: 'Animal Medical Center of Lehigh',
    role: 'Veterinarian',
    phone: '',
    city: 'FORT MYERS',
    state: 'FL',
    country: 'US',
    postalCode: '33905',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:10:20 EST',
  },
  {
    id: 'vmx-2026-80',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Tomer Ronai',
    email: 'tronai@gmail.com',
    company: 'Kensington Veterinary Hospital',
    role: '',
    phone: '',
    city: 'San Diego',
    state: 'CA',
    country: 'US',
    postalCode: '92108',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:12:00 EST',
  },
  {
    id: 'vmx-2026-81',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Bryn Jones',
    email: 'brynalunjones@gmail.com',
    company: 'Willows Referral Service',
    role: 'Medicine Diplomate',
    phone: '',
    city: 'Bromsgrove',
    state: 'WOR',
    country: 'GB',
    postalCode: 'B60 2NJ',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:14:47 EST',
  },
  {
    id: 'vmx-2026-82',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Daisy Sutton',
    email: 'daisy.sutton@dragonvet.co.uk',
    company: 'Dragon Veterinary Centre',
    role: 'Veterinary Surgeon',
    phone: '',
    city: 'Cheltenham',
    state: 'GLS',
    country: 'GB',
    postalCode: 'GL50 4SH',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:14:50 EST',
  },
  {
    id: 'vmx-2026-83',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Amy Shelden',
    email: 'sheldena14@gmail.com',
    company: 'CityVet',
    role: 'Veterinarian',
    phone: '',
    city: 'Flower Mound',
    state: 'TX',
    country: 'US',
    postalCode: '75022',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:16:15 EST',
  },
  {
    id: 'vmx-2026-84',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kayla Lee',
    email: 'kayla@alohavetclinic.com',
    company: 'Aloha Veterinary Clinic',
    role: 'Veterinarian/Owner',
    phone: '9564521535',
    city: 'Laguna Vista',
    state: 'TX',
    country: 'US',
    postalCode: '78578',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:16:18 EST',
  },
  {
    id: 'vmx-2026-85',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Russell Oakley',
    email: 'oakleydvm@aol.com',
    company: 'Oakley Veterinary Relief Services',
    role: 'DVM',
    phone: '',
    city: 'Richmond',
    state: 'TX',
    country: 'US',
    postalCode: '77469',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:17:50 EST',
  },
  {
    id: 'vmx-2026-86',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Bridget Ferguson',
    email: 'avian51@gmail.com',
    company: 'Pine Tree Veterinary Hospital',
    role: 'Owner',
    phone: '',
    city: 'Ravensdale',
    state: 'WA',
    country: 'US',
    postalCode: '98051',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:19:55 EST',
  },
  {
    id: 'vmx-2026-87',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Vinita Su',
    email: 'vinita.su@banfield.com',
    company: 'Banfield',
    role: '',
    phone: '',
    city: 'Brooklyn',
    state: 'NY',
    country: 'US',
    postalCode: '11209',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:25:01 EST',
  },
  {
    id: 'vmx-2026-88',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jennifer Schurrer',
    email: 'jschurrer10@gmail.com',
    company: 'East Central Veterinarians',
    role: '',
    phone: '',
    city: 'Mora',
    state: 'MN',
    country: 'US',
    postalCode: '55051',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:28:10 EST',
  },
  {
    id: 'vmx-2026-89',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Laura Byers',
    email: 'byer0050@yahoo.com',
    company: 'East Central Veterinarians',
    role: 'DVM',
    phone: '',
    city: 'Ham Lake',
    state: 'MN',
    country: 'US',
    postalCode: '55304',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:28:12 EST',
  },
  {
    id: 'vmx-2026-90',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Christine Duree',
    email: 'cdureevet@comcast.net',
    company: 'Homestead Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Aurora',
    state: 'CO',
    country: 'US',
    postalCode: '80016',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:28:15 EST, 2026-01-17 17:35:21 EST',
  },
  {
    id: 'vmx-2026-91',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Alison Beaulieu',
    email: 'drb@mydmah.com',
    company: 'Dickin Memorial Animal Hospital',
    role: 'veterinarian',
    phone: '',
    city: 'Endicott',
    state: 'NY',
    country: 'US',
    postalCode: '13760',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:29:03 EST',
  },
  {
    id: 'vmx-2026-92',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Caitlin Goddard',
    email: 'cpvarner4@gmail.com',
    company: 'Copper Basin Veterinary Clinic',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Ellijay',
    state: 'GA',
    country: 'US',
    postalCode: '30540',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:30:07 EST',
  },
  {
    id: 'vmx-2026-93',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Emily Brink',
    email: 'emilykbrink@gmail.com',
    company: 'Veterinary Urgent Care Center',
    role: 'Veterinarian',
    phone: '',
    city: 'Kingston',
    state: 'MA',
    country: 'US',
    postalCode: '02364',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:30:11 EST',
  },
  {
    id: 'vmx-2026-94',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Dalena Hobbs',
    email: 'dalenashobbs820@gmail.com',
    company: 'Kingsport Veterinary Hospital',
    role: 'Associate Veterinarin',
    phone: '',
    city: 'Dungannon',
    state: 'VA',
    country: 'US',
    postalCode: '24245',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:30:14 EST',
  },
  {
    id: 'vmx-2026-95',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Susan Seman',
    email: 'sue@hartvillevet.com',
    company: 'Hartville Veterinary Clinic',
    role: 'Veterinarian',
    phone: '13308779591',
    city: 'Ravenna',
    state: 'OH',
    country: 'US',
    postalCode: '44266',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:35:07 EST',
  },
  {
    id: 'vmx-2026-96',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Vanessa Perez',
    email: 'vanessaperez93@gmail.com',
    company: 'Vetco',
    role: '',
    phone: '',
    city: 'Milwaukie',
    state: 'OR',
    country: 'US',
    postalCode: '97222',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-17 17:35:18 EST',
  },
  {
    id: 'vmx-2026-97',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'GREGORY SANTANER',
    email: 'contact@vetonetwork.com',
    company: 'VETONETWORK',
    role: 'CEO',
    phone: '',
    city: 'LORIENT',
    state: '',
    country: 'FR',
    postalCode: '56100',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:01:45 EST',
  },
  {
    id: 'vmx-2026-98',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Ned Allen',
    email: 'tigeandkaren@yahoo.com',
    company: 'Jones Animal Hospital',
    role: 'D.V.M.',
    phone: '',
    city: 'Bristol',
    state: 'TN',
    country: 'US',
    postalCode: '37620',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:10:06 EST',
  },
  {
    id: 'vmx-2026-99',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kadie Cheeks',
    email: 'kadie.cheeks@gmail.com',
    company: 'St Francis Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Augusta',
    state: 'GA',
    country: 'US',
    postalCode: '30909',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:15:46 EST',
  },
  {
    id: 'vmx-2026-100',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Michelle Werden',
    email: 'mwcurly@aol.com',
    company: 'Plummer Pet Hospital',
    role: 'CVT/Hospital Manager',
    phone: '',
    city: 'St. Petersburg',
    state: 'FL',
    country: 'US',
    postalCode: '33710',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:16:59 EST',
  },
  {
    id: 'vmx-2026-101',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Fred Cohen',
    email: 'fcohen2029@gmail.com',
    company: 'Westview Animal Hospital- Vetcor',
    role: 'Chief of Staff',
    phone: '',
    city: 'Catonsville',
    state: 'MD',
    country: 'US',
    postalCode: '21228',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:17:03 EST',
  },
  {
    id: 'vmx-2026-102',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Cynthia Orange',
    email: 'cynthia.orange1988@gmail.com',
    company: 'Paw Haven Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Auburndale',
    state: 'FL',
    country: 'US',
    postalCode: '33823',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:17:06 EST',
  },
  {
    id: 'vmx-2026-103',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Carlos Basabe',
    email: 'basabevetrelief@outlook.com',
    company: 'Viera East Veterinary Center',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Rockledge',
    state: 'FL',
    country: 'US',
    postalCode: '32955',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:18:35 EST',
  },
  {
    id: 'vmx-2026-104',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Leah Montgomery',
    email: 'leahmont@telus.net',
    company: 'Riverwood Veterinary Clinic',
    role: 'veterinarian/owner',
    phone: '',
    city: 'Port Coquitlam',
    state: 'BC',
    country: 'CA',
    postalCode: 'V3B 0L4',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:21:02 EST',
  },
  {
    id: 'vmx-2026-105',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Tamantha Hickok',
    email: 'tamanthahickok@comcast.net',
    company: 'Animal Medical Center',
    role: 'Veterinarian',
    phone: '',
    city: 'Muncie',
    state: 'IN',
    country: 'US',
    postalCode: '47304',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:24:19 EST',
  },
  {
    id: 'vmx-2026-106',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Tev Barros',
    email: 'drbarros@orah.vet',
    company: 'Oak Ridge Animal Hospital',
    role: 'Owner/Veterinarian',
    phone: '',
    city: 'Greensboro',
    state: 'NC',
    country: 'US',
    postalCode: '27403',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:29:35 EST',
  },
  {
    id: 'vmx-2026-107',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Erin Graves',
    email: 'eringraves@comcast.net',
    company: 'River Ridge Animal Hospital',
    role: '',
    phone: '',
    city: 'Dixon',
    state: 'IL',
    country: 'US',
    postalCode: '61021',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:33:55 EST',
  },
  {
    id: 'vmx-2026-108',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Michelle Scott',
    email: 'michellescottdvm@gmail.com',
    company: 'Carlyle Animal Hospital',
    role: 'Owner/DVM',
    phone: '618-594-4515',
    city: 'Carlyle',
    state: 'IL',
    country: 'US',
    postalCode: '62231',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:35:49 EST',
  },
  {
    id: 'vmx-2026-109',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'robin Hayes-moser',
    email: 'rrmoser@vnet.net',
    company: 'foster animal hospital',
    role: 'veterinarian',
    phone: '',
    city: 'concord',
    state: 'NC',
    country: 'US',
    postalCode: '28025',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:35:58 EST',
  },
  {
    id: 'vmx-2026-110',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Lisa Ciucci',
    email: 'lisaciucci@gmail.com',
    company: 'Gardens Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Palm Beach Gardens',
    state: 'FL',
    country: 'US',
    postalCode: '33410',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:40:13 EST',
  },
  {
    id: 'vmx-2026-111',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Scott Neabore',
    email: 'svneabore@gmail.com',
    company: 'Neabore Veterinary Clinic',
    role: 'Veterinarian',
    phone: '',
    city: 'Haddon Township',
    state: 'NJ',
    country: 'US',
    postalCode: '08108',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:46:25 EST',
  },
  {
    id: 'vmx-2026-112',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Michelle McHenry',
    email: 'mchenry.michelle@gmail.com',
    company: 'Neabore Veterinary Clinic',
    role: 'Veterinary Technician',
    phone: '',
    city: 'Haddonfield',
    state: 'NJ',
    country: 'US',
    postalCode: '08033',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:46:30 EST',
  },
  {
    id: 'vmx-2026-113',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Patricia Ader',
    email: 'doctorvet369@gmail.com',
    company: 'Animal care services',
    role: 'Dvm',
    phone: '14017386695',
    city: 'Warwick',
    state: 'RI',
    country: 'US',
    postalCode: '02886',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:54:00 EST',
  },
  {
    id: 'vmx-2026-114',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Katrina Posey',
    email: 'katrinajposey@gmail.com',
    company: 'Quail Corners Animal Hospital',
    role: 'Dr.',
    phone: '',
    city: 'Raleigh',
    state: 'NC',
    country: 'US',
    postalCode: '27603',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 10:55:04 EST',
  },
  {
    id: 'vmx-2026-115',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: "Manon L'Ecuyer",
    email: 'manon.lecuyer@boehringer-ingelheim.com',
    company: 'BOEHRINGER INGELHEIM',
    role: 'Technical services veterinarian - specialist',
    phone: '',
    city: 'Saint-Sauveur',
    state: 'QC',
    country: 'CA',
    postalCode: 'J0R1R2',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:03:46 EST, 2026-01-18 11:13:19 EST',
  },
  {
    id: 'vmx-2026-116',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jennifer Leven',
    email: 'jennifer.engelleven@gmail.com',
    company: 'Westview Animal Hospital',
    role: 'Veterinary Technician',
    phone: '',
    city: 'Elkridge',
    state: 'MD',
    country: 'US',
    postalCode: '21075',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:22:55 EST',
  },
  {
    id: 'vmx-2026-117',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'tabatha chafkin, dvm',
    email: 'tabatha13@earthlink.net',
    company: 'port royal veterinary hospital',
    role: 'dr',
    phone: '',
    city: 'savannah',
    state: 'GA',
    country: 'US',
    postalCode: '31420',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:25:19 EST',
  },
  {
    id: 'vmx-2026-118',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Ann Toto',
    email: 'atotodvm@gmail.com',
    company: 'Floral City Animal Clinic',
    role: 'Veterinarian/Owner',
    phone: '',
    city: 'Inverness',
    state: 'FL',
    country: 'US',
    postalCode: '34450',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:31:58 EST',
  },
  {
    id: 'vmx-2026-119',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Gal Elhalal',
    email: 'gal.elhalal@vetmarket.co.il',
    company: 'VETMARKET ltd',
    role: 'Vetmarket LTD',
    phone: '',
    city: 'Industrial Park Hevel Modiin',
    state: '',
    country: 'IL',
    postalCode: '6085001',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:41:38 EST',
  },
  {
    id: 'vmx-2026-120',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jacqueline Farraher',
    email: 'jacqueline.farraher@thrivepet.com',
    company: 'Billerica Veterinary Hospital (Thrive Pet Healthcare)',
    role: 'Veterinary Technician Supervisor',
    phone: '',
    city: 'Billerica',
    state: 'MA',
    country: 'US',
    postalCode: '01821',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:42:15 EST, 2026-01-18 12:00:53 EST',
  },
  {
    id: 'vmx-2026-121',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sarah Mateer',
    email: 'sarah4evrsarah@gmail.com',
    company: 'Hershey Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '',
    city: 'Annville',
    state: 'PA',
    country: 'US',
    postalCode: '17003',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:45:43 EST',
  },
  {
    id: 'vmx-2026-122',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kim Roden',
    email: 'mammaslilrebel@yahoo.com',
    company: 'Hershey Veterinary Hospital',
    role: 'Office Manager',
    phone: '',
    city: 'Bainbrige',
    state: 'PA',
    country: 'US',
    postalCode: '17022',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:45:47 EST',
  },
  {
    id: 'vmx-2026-123',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kelly Lambert',
    email: 'klambertlvmt@outlook.com',
    company: 'Maryville Small Animal Medical Center',
    role: 'LVMT',
    phone: '',
    city: 'Englewood',
    state: 'TN',
    country: 'US',
    postalCode: '37329',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:51:18 EST',
  },
  {
    id: 'vmx-2026-124',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Victoria Hammond',
    email: 'victoria.shelah1992@gmail.com',
    company: 'Maryville Small Animal Medical Center',
    role: 'LVMT',
    phone: '',
    city: 'Knoxville',
    state: 'TN',
    country: 'US',
    postalCode: '37931',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 11:51:21 EST',
  },
  {
    id: 'vmx-2026-125',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Michael Goldstein',
    email: 'goldsteindvm@aol.com',
    company: 'Billerica Veterinary Hospital',
    role: 'Medical Director',
    phone: '',
    city: 'Billerica',
    state: 'MA',
    country: 'US',
    postalCode: '01821',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:00:58 EST',
  },
  {
    id: 'vmx-2026-126',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Patrick Champlin',
    email: 'northmidwayvet@msn.com',
    company: 'Russell Creek Pet Hospital',
    role: 'Associate Veterinarian',
    phone: '12145478387',
    city: 'Little Elm',
    state: 'TX',
    country: 'US',
    postalCode: '75068',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:02:48 EST',
  },
  {
    id: 'vmx-2026-127',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Cole Tucker',
    email: 'ark.drtucker@outlook.com',
    company: 'Ark Animal Hospital',
    role: 'Owner - Veterinarian',
    phone: '',
    city: 'Liberty',
    state: 'MO',
    country: 'US',
    postalCode: '64068',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:09:24 EST',
  },
  {
    id: 'vmx-2026-128',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jeff Denny',
    email: 'jeffrdenny@att.net',
    company: 'Ark Animal Hospital',
    role: '',
    phone: '',
    city: 'LIBERTY',
    state: 'MO',
    country: 'US',
    postalCode: '64068',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:09:30 EST',
  },
  {
    id: 'vmx-2026-129',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Arnaldo Perez',
    email: 'pinero62ap@gmail.com',
    company: 'Suntree Animal Clinic',
    role: 'Veterinarian',
    phone: '',
    city: 'Melbourne',
    state: 'FL',
    country: 'US',
    postalCode: '32940',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:12:27 EST',
  },
  {
    id: 'vmx-2026-130',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Danielle Paul',
    email: 'dr.dpaul@americanveterinarygroup.com',
    company: 'Animal Clinic of West Lake Worth',
    role: 'Veterinarian',
    phone: '',
    city: 'Boynton Beach',
    state: 'FL',
    country: 'US',
    postalCode: '33436',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:15:53 EST',
  },
  {
    id: 'vmx-2026-131',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kristy LONGPRE',
    email: 'kristy.longpre@vetmab.bio',
    company: 'Vetmab Bio',
    role: 'Director of Operations',
    phone: '8624523863',
    city: 'San Diego',
    state: 'AS',
    country: 'US',
    postalCode: '92116',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:19:52 EST',
  },
  {
    id: 'vmx-2026-132',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Denise Bevers',
    email: 'denise.bevers@vetmab.bio',
    company: 'VETmAb Bio',
    role: 'Founder & CEO',
    phone: '',
    city: 'San Diego',
    state: 'CA',
    country: 'US',
    postalCode: '92106',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:19:56 EST',
  },
  {
    id: 'vmx-2026-133',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Christine Lee',
    email: 'cmleedvm@yahoo.com',
    company: 'VCA Brighton Animal Hospital',
    role: 'Dr.',
    phone: '',
    city: 'Brighton',
    state: 'MI',
    country: 'US',
    postalCode: '48116',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:21:00 EST',
  },
  {
    id: 'vmx-2026-134',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Melissa Ruddy',
    email: 'melissaruddy828@aol.com',
    company: 'Juniper Valley Animal Hospital',
    role: 'LVT',
    phone: '',
    city: 'East Rockaway',
    state: 'NY',
    country: 'US',
    postalCode: '11518',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:25:45 EST',
  },
  {
    id: 'vmx-2026-135',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sarah Mclean',
    email: 'mclean_sk@yahoo.com',
    company: 'Pebblebrooke Animal Hospital',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Naples',
    state: 'FL',
    country: 'US',
    postalCode: '34120',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:25:51 EST',
  },
  {
    id: 'vmx-2026-136',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Rachel Wander-Peyser',
    email: 'doglvr@peyser.net',
    company: 'Healthy Pet Mobile Vet LTD',
    role: 'Veterinarian & Owner',
    phone: '',
    city: 'Frederick',
    state: 'MD',
    country: 'US',
    postalCode: '21701',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:25:57 EST',
  },
  {
    id: 'vmx-2026-137',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'James Malatesta',
    email: 'jamesmalatesta13@icloud.com',
    company: 'Triangle Veterinary Hospital',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Raleigh',
    state: 'NC',
    country: 'US',
    postalCode: '27604',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:34:08 EST',
  },
  {
    id: 'vmx-2026-138',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Rebecca Schuber',
    email: 'rebecca.schuber@bluepearlvet.com',
    company: 'BluePearl',
    role: 'Emergency Veterinarian',
    phone: '',
    city: 'Raleigh',
    state: 'NC',
    country: 'US',
    postalCode: '27604',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:34:11 EST',
  },
  {
    id: 'vmx-2026-139',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'blair bailey',
    email: 'blair97470@yahoo.com',
    company: 'bailey veterinary clinic',
    role: 'retired',
    phone: '',
    city: 'roseburg',
    state: 'OR',
    country: 'US',
    postalCode: '97471',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:37:42 EST, 2026-01-19 16:51:24 EST',
  },
  {
    id: 'vmx-2026-140',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Elizabeth Caesar',
    email: 'caesar511@outlook.com',
    company: 'Abby Road Veterinary Hospital',
    role: '',
    phone: '',
    city: 'Northampton',
    state: 'PA',
    country: 'US',
    postalCode: '18067',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:42:41 EST',
  },
  {
    id: 'vmx-2026-141',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Mason Caesar',
    email: 'masonjc9@outlook.com',
    company: 'Abby Road Veterinary Hospital',
    role: '',
    phone: '',
    city: 'Northampton',
    state: 'PA',
    country: 'US',
    postalCode: '18067',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:42:43 EST',
  },
  {
    id: 'vmx-2026-142',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Stephanie Letarte',
    email: 'sletarte11@gmail.com',
    company: 'Premier VetCare',
    role: '',
    phone: '',
    city: 'Murfreesboro',
    state: 'TN',
    country: 'US',
    postalCode: '37128',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:50:16 EST',
  },
  {
    id: 'vmx-2026-143',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Caroline Johnson',
    email: 'caro8388@gmail.com',
    company: 'Premier Vetcare',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Nashville',
    state: 'TN',
    country: 'US',
    postalCode: '37221',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:50:18 EST',
  },
  {
    id: 'vmx-2026-144',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Morgan Miller',
    email: 'drmiller@westervillepets.com',
    company: 'Westerville Veterinary Clinic',
    role: '',
    phone: '',
    city: 'Powell',
    state: 'OH',
    country: 'US',
    postalCode: '43065',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:55:01 EST',
  },
  {
    id: 'vmx-2026-145',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Shelby Ladner',
    email: 'shelbyladnerdvm@gmail.com',
    company: 'Northwood Hills Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Kiln',
    state: 'MS',
    country: 'US',
    postalCode: '39556',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:57:16 EST',
  },
  {
    id: 'vmx-2026-146',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Zana Ransom',
    email: 'zanabwatkins@gmail.com',
    company: 'Fayette Veterinary Hospital',
    role: '',
    phone: '',
    city: 'Shady Spring',
    state: 'WV',
    country: 'US',
    postalCode: '25918',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 12:57:20 EST',
  },
  {
    id: 'vmx-2026-147',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Lily Vallone',
    email: 'lmvt1122@yahoo.com',
    company: 'Gardens animal hospital',
    role: 'CVT',
    phone: '',
    city: 'Palm Beach Gardens',
    state: 'FL',
    country: 'US',
    postalCode: '33418',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:03:30 EST',
  },
  {
    id: 'vmx-2026-148',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Laura Murray',
    email: 'plainjanemurray9326@gmail.com',
    company: 'Gardens Animal Hospital',
    role: 'CVT',
    phone: '',
    city: 'Loxahatchee',
    state: 'FL',
    country: 'US',
    postalCode: '33470',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:03:33 EST',
  },
  {
    id: 'vmx-2026-149',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Bret Peterson',
    email: 'bpeterson17@hotmail.com',
    company: 'Laketown Animal Hospital',
    role: '',
    phone: '',
    city: 'Springfield',
    state: 'IL',
    country: 'US',
    postalCode: '62703',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:09:33 EST',
  },
  {
    id: 'vmx-2026-150',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Allyna Tucker',
    email: 'lynaboo18@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: 'Springfield',
    state: 'IL',
    country: 'US',
    postalCode: '62703',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:09:42 EST',
  },
  {
    id: 'vmx-2026-151',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Britney Porter',
    email: 'zapbappop366@gmail.com',
    company: 'Laketown Animal Hospital',
    role: 'CVT',
    phone: '2175294211',
    city: 'Springfield',
    state: 'IL',
    country: 'US',
    postalCode: '62703',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:09:46 EST',
  },
  {
    id: 'vmx-2026-152',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Aaron Felgenhauer',
    email: 'acfelgenhauer@gmail.com',
    company: 'Laketown Animal Hospital',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Chatham',
    state: 'IL',
    country: 'US',
    postalCode: '62629',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:10:04 EST',
  },
  {
    id: 'vmx-2026-153',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Josh Godsey',
    email: 'jgodsey1384@gmail.com',
    company: 'N/A',
    role: 'Veterinarian',
    phone: '',
    city: 'Independence',
    state: 'KY',
    country: 'US',
    postalCode: '41051',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:17:09 EST',
  },
  {
    id: 'vmx-2026-154',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Elise McDonough',
    email: 'elisemcdonough2@gmail.com',
    company: 'Billerica Veterinary Hospital, Thrive',
    role: 'veterinarian',
    phone: '',
    city: 'Waltham',
    state: 'MA',
    country: 'US',
    postalCode: '02453',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:21:32 EST',
  },
  {
    id: 'vmx-2026-155',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Lori Ward',
    email: 'ward.lori.leigh@gmail.com',
    company: 'Ward Veterinary Services',
    role: 'Owner',
    phone: '',
    city: 'Tupelo',
    state: 'MS',
    country: 'US',
    postalCode: '38801',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:25:04 EST',
  },
  {
    id: 'vmx-2026-156',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Dan Goldner',
    email: 'goldnervmd@comcast.net',
    company: 'Queen Village Animal Hospital',
    role: 'Co owner',
    phone: '',
    city: 'Phila',
    state: 'PA',
    country: 'US',
    postalCode: '19147',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:31:09 EST',
  },
  {
    id: 'vmx-2026-157',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'PAT FLEMING RUSSO',
    email: 'askthevet@wowway.com',
    company: 'LEVAN ROAD VET HOSPITAL',
    role: 'VETERINARIAN',
    phone: '',
    city: 'LIVONIA',
    state: 'MI',
    country: 'US',
    postalCode: '48150',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:38:04 EST',
  },
  {
    id: 'vmx-2026-158',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Brittany Greene',
    email: 'bbockanic17@gmail.com',
    company: 'Crago Veterinary Clinic',
    role: 'Veterinarian',
    phone: '',
    city: 'Boardman',
    state: 'OH',
    country: 'US',
    postalCode: '44512',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:41:37 EST',
  },
  {
    id: 'vmx-2026-159',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kristin Mariash',
    email: 'kpmariash@yahoo.com',
    company: 'Varsity Veterinary Center',
    role: 'Veterinarian',
    phone: '',
    city: 'Orlando',
    state: 'FL',
    country: 'US',
    postalCode: '32803',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:45:18 EST',
  },
  {
    id: 'vmx-2026-160',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Philip Baxter',
    email: 'pwbaxter@bellsouth.net',
    company: 'Little Cahaba Animal Hospital',
    role: 'Associate veterinarian',
    phone: '',
    city: 'Rainbow City',
    state: 'AL',
    country: 'US',
    postalCode: '35906',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 13:45:36 EST',
  },
  {
    id: 'vmx-2026-161',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Leah Marshall',
    email: 'lmarshall29@hawkmail.hccfl.edu',
    company: 'N/A',
    role: 'Veterinary technician student',
    phone: '',
    city: 'Winterhaven',
    state: 'FL',
    country: 'US',
    postalCode: '33884',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:00:50 EST',
  },
  {
    id: 'vmx-2026-162',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Nico Galeano',
    email: 'ngaleano2@hawkmail.hccfl.edu',
    company: 'integrative animal hospital',
    role: 'Veterinary Technician',
    phone: '',
    city: 'orlando',
    state: 'FL',
    country: 'US',
    postalCode: '32825',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:00:52 EST',
  },
  {
    id: 'vmx-2026-163',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Darryl Leslie',
    email: 'darryl@leslieanimal.com',
    company: 'Leslie Animal Clinic PC',
    role: 'Owner/DVM',
    phone: '',
    city: 'Alamogordo',
    state: 'NM',
    country: 'US',
    postalCode: '88310',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:01:00 EST',
  },
  {
    id: 'vmx-2026-164',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kim Leslie',
    email: 'KALeslie90@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: 'Alamogordo',
    state: 'NM',
    country: 'US',
    postalCode: '88310',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:01:05 EST',
  },
  {
    id: 'vmx-2026-165',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Susan Oltman',
    email: 'wehrhouse1@gmail.com',
    company: 'Triadelphia Veterinary Clinic',
    role: 'Veterinarian/owner',
    phone: '14435359257',
    city: 'Sykesville',
    state: 'MD',
    country: 'US',
    postalCode: '21784',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:16:42 EST',
  },
  {
    id: 'vmx-2026-166',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Heather Stup',
    email: 'heatherstup@comcast.net',
    company: 'Triadelphia Veterinary Clinic',
    role: 'Owner',
    phone: '14435359257',
    city: 'Glenelg',
    state: 'MD',
    country: 'US',
    postalCode: '21737',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:16:44 EST',
  },
  {
    id: 'vmx-2026-167',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Gabrielle Leather',
    email: 'gabbyleather94@gmail.com',
    company: 'VetEvolve/ Manchester Veterinary Services',
    role: 'Dr',
    phone: '',
    city: 'Hampstead',
    state: 'MD',
    country: 'US',
    postalCode: '21074',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:39:07 EST',
  },
  {
    id: 'vmx-2026-168',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Corinne Kilmer',
    email: 'corinnekilmerdvm@gmail.com',
    company: 'South Peak Veterinary Hospital (Heart + Paw)',
    role: 'Associate Doctor',
    phone: '',
    city: 'Saugerties',
    state: 'NY',
    country: 'US',
    postalCode: '12477',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:39:10 EST',
  },
  {
    id: 'vmx-2026-169',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sarah Carter',
    email: 'smit1659@gmail.com',
    company: 'HSHV',
    role: 'Associate',
    phone: '',
    city: 'Milan',
    state: 'MI',
    country: 'US',
    postalCode: '48160',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:41:48 EST',
  },
  {
    id: 'vmx-2026-170',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Christa Lambert',
    email: 'christa.r.lambert@gmail.com',
    company: 'Springtown Veterinary Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'New Braunfels',
    state: 'TX',
    country: 'US',
    postalCode: '78130',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:44:42 EST',
  },
  {
    id: 'vmx-2026-171',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Steve Morris',
    email: 'steve@darienac.com',
    company: 'Darien Animal Clinic',
    role: 'Hospital Administrator',
    phone: '',
    city: 'Darien',
    state: 'IL',
    country: 'US',
    postalCode: '60561',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:47:29 EST',
  },
  {
    id: 'vmx-2026-172',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sharon Swift',
    email: 'swift@pcvh.vet',
    company: 'Paws and Claws',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Tallahassee',
    state: 'NC',
    country: 'US',
    postalCode: '32309',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:48:14 EST',
  },
  {
    id: 'vmx-2026-173',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sara Hearn',
    email: 'sara@hearn-family.net',
    company: 'N/A',
    role: '',
    phone: '',
    city: 'Gainesville',
    state: 'FL',
    country: 'US',
    postalCode: '32641',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:48:17 EST',
  },
  {
    id: 'vmx-2026-174',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Makenzie Sanders',
    email: 'msanders@southerntrailsvet.com',
    company: 'Southern Trails Vet',
    role: 'Veterinarian',
    phone: '',
    city: 'Barnwell',
    state: 'SC',
    country: 'US',
    postalCode: '29812',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 14:54:44 EST, 2026-01-18 14:55:21 EST',
  },
  {
    id: 'vmx-2026-175',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Julia Roberts, LVT',
    email: 'cowgrl159@yahoo.com',
    company: 'Edinburgh Animal Hospital',
    role: 'LVT',
    phone: '',
    city: 'Chesapeake',
    state: 'VA',
    country: 'US',
    postalCode: '23322',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:03:50 EST',
  },
  {
    id: 'vmx-2026-176',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Dena Krueger',
    email: 'denaklong@hotmail.com',
    company: 'Hosanna Animal Hospital',
    role: 'owner',
    phone: '',
    city: 'Titusville',
    state: 'FL',
    country: 'US',
    postalCode: '32780',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:06:03 EST',
  },
  {
    id: 'vmx-2026-177',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Ruben Pabon Padin',
    email: 'padin_ruben@yahoo.com',
    company: 'Vetco Total Care',
    role: 'Veterinarian',
    phone: '',
    city: 'Kissimmee',
    state: 'FL',
    country: 'US',
    postalCode: '34746',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:11:39 EST, 2026-01-18 15:12:43 EST',
  },
  {
    id: 'vmx-2026-178',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Zandra DiEugenio',
    email: 'nbmgr@newberryahgroup.com',
    company: 'Newberry Animal Hospital',
    role: 'Practice Manager',
    phone: '',
    city: 'Ocala',
    state: 'FL',
    country: 'US',
    postalCode: '34482',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:11:43 EST',
  },
  {
    id: 'vmx-2026-179',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Joshua Demonte',
    email: 'demontejosh@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: 'Groveland',
    state: 'FL',
    country: 'US',
    postalCode: '34736',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:11:51 EST',
  },
  {
    id: 'vmx-2026-180',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Angela Albers',
    email: 'draaoutofoffice@gmail.com',
    company: 'Stow Kent Animal Hospital',
    role: 'Dr.',
    phone: '',
    city: 'Kent',
    state: 'OH',
    country: 'US',
    postalCode: '44240',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:19:35 EST',
  },
  {
    id: 'vmx-2026-181',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Eric Brooks',
    email: 'ericebrooks@yahoo.com',
    company: 'Stow Kent Animal Hospital',
    role: 'Dr.',
    phone: '',
    city: 'Kent',
    state: 'OH',
    country: 'US',
    postalCode: '44240',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:19:38 EST',
  },
  {
    id: 'vmx-2026-182',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jennifer Torrescano',
    email: 'pawsomerelief@gmail.com',
    company: 'Pawsome Veterinary Relief',
    role: 'Dr.',
    phone: '19126557529',
    city: 'Richmond Hill',
    state: 'GA',
    country: 'US',
    postalCode: '31324',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:26:30 EST',
  },
  {
    id: 'vmx-2026-183',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Gregory Torrescano',
    email: 'alant1982@yahoo.com',
    company: 'Pawsome Veterinary Relief',
    role: 'Practice Manager',
    phone: '912-655-4416',
    city: 'Richmond Hill',
    state: 'GA',
    country: 'US',
    postalCode: '31324',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:26:35 EST',
  },
  {
    id: 'vmx-2026-184',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Deborah Donohue',
    email: 'duffy347@msn.com',
    company: 'Chewy, Inc.',
    role: 'Veterinarian',
    phone: '',
    city: 'Greensburg',
    state: 'PA',
    country: 'US',
    postalCode: '15601',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:39:59 EST',
  },
  {
    id: 'vmx-2026-185',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kim Lewis',
    email: 'kimlewisdogtor@gmail.com',
    company: 'Mesquite Veterinary Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Tucson',
    state: 'AZ',
    country: 'US',
    postalCode: '85739',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:43:22 EST',
  },
  {
    id: 'vmx-2026-186',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kimberly Sunderland',
    email: 'dr.kimberly.sunderland@gmail.com',
    company: 'Falcon Pass Animal Hospital',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Houston',
    state: 'TX',
    country: 'US',
    postalCode: '77062',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 15:56:37 EST',
  },
  {
    id: 'vmx-2026-187',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kelly Rew',
    email: 'krew530@gmail.com',
    company: 'Live With Grace Animal Hospital',
    role: 'Business Owner | Medical Director',
    phone: '',
    city: 'Stuart',
    state: 'FL',
    country: 'US',
    postalCode: '34997',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:36:41 EST, 2026-01-18 16:39:25 EST',
  },
  {
    id: 'vmx-2026-188',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Keith Turner',
    email: 'kturner@lwgvet.com',
    company: '',
    role: '',
    phone: '',
    city: 'Stewart',
    state: 'FL',
    country: 'US',
    postalCode: '34995',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:36:46 EST',
  },
  {
    id: 'vmx-2026-189',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Paul Williams',
    email: 'stah2000@bellsouth.net',
    company: 'seminole trail animal hospital',
    role: 'Owner',
    phone: '',
    city: 'Winter Springs',
    state: 'FL',
    country: 'US',
    postalCode: '32708',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:38:53 EST',
  },
  {
    id: 'vmx-2026-190',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Dr. Susanne Heartsill',
    email: 'susanne.heartsill@ceva.com',
    company: 'Ceva Animal Health',
    role: 'Chief Medical Officer',
    phone: '9139454430',
    city: 'Lenexa',
    state: 'KS',
    country: 'US',
    postalCode: '66215',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:38:57 EST',
  },
  {
    id: 'vmx-2026-191',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Sharon Perkins',
    email: 'perkins.sharon80@yahoo.com',
    company: 'Park Animal Hospital LLC',
    role: 'Receptionist',
    phone: '',
    city: 'Pinellas Park',
    state: 'FL',
    country: 'US',
    postalCode: '33781',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:39:00 EST, 2026-01-18 16:39:10 EST',
  },
  {
    id: 'vmx-2026-192',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jenny Glover',
    email: 'catnipfairy@gmail.com',
    company: 'Park Animal Hospital LLC',
    role: 'Head Technician',
    phone: '',
    city: 'ST PETERSBURG',
    state: 'FL',
    country: 'US',
    postalCode: '33713',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:39:14 EST',
  },
  {
    id: 'vmx-2026-193',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Melinda Eyrich',
    email: 'abqvet@gmail.com',
    company: 'Mission Veterinary Clinic',
    role: 'Veterinarian/Owner',
    phone: '',
    city: 'Rio Rancho',
    state: 'NM',
    country: 'US',
    postalCode: '87124',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:39:16 EST',
  },
  {
    id: 'vmx-2026-194',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Christopher Eyrich',
    email: 'christopher_missionvet@outlook.com',
    company: 'Mission Veterinary Clinic',
    role: 'Practice Administrator',
    phone: '',
    city: 'Rio Rancho',
    state: 'NM',
    country: 'US',
    postalCode: '87124',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:39:19 EST',
  },
  {
    id: 'vmx-2026-195',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Karen Brown',
    email: 'boxerdoc@msn.com',
    company: 'Greenbriar Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Jacksonville',
    state: 'FL',
    country: 'US',
    postalCode: '32259',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:39:22 EST',
  },
  {
    id: 'vmx-2026-196',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Lauren Wright',
    email: 'lwrght777@gmail.com',
    company: 'Barker Animal Hospital',
    role: 'Office Manager',
    phone: '',
    city: 'Norfolk',
    state: 'VA',
    country: 'US',
    postalCode: '23504',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 16:55:40 EST',
  },
  {
    id: 'vmx-2026-197',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Caitlin Labo',
    email: 'clabo@umich.edu',
    company: 'The Cat Practice',
    role: '',
    phone: '',
    city: 'Troy',
    state: 'MI',
    country: 'US',
    postalCode: '48084',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 17:04:11 EST',
  },
  {
    id: 'vmx-2026-198',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Bonnie Bragdon',
    email: 'bbragdon@cpbio.com',
    company: 'Center Point Bio-Tech',
    role: 'Chief Commercial Officer',
    phone: '8032700024',
    city: 'LAS VEGAS',
    state: 'NV',
    country: 'US',
    postalCode: '89119',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-18 17:06:11 EST',
  },
  {
    id: 'vmx-2026-199',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Denise Domingues',
    email: 'denisedomingues@aol.com',
    company: 'Lafayette Veterinary Care Center',
    role: 'Veterinary Nurse',
    phone: '',
    city: 'Lafayette',
    state: 'LA',
    country: 'US',
    postalCode: '70506',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 09:22:06 EST',
  },
  {
    id: 'vmx-2026-200',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Pedro Gomez',
    email: 'ahmpvettech@outlook.com',
    company: 'Animal Hospital of Morris Park',
    role: 'Veterinary Technician',
    phone: '',
    city: 'Bronx',
    state: 'NY',
    country: 'US',
    postalCode: '10461',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 09:57:30 EST',
  },
  {
    id: 'vmx-2026-201',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Susan Ferguson',
    email: 'shferguson74@hotmail.com',
    company: 'Wimberley Vet Clinic',
    role: 'DVM',
    phone: '',
    city: 'Wimberley',
    state: 'TX',
    country: 'US',
    postalCode: '78676',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 10:23:01 EST',
  },
  {
    id: 'vmx-2026-202',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: "Samantha O'Gorman",
    email: 'drsamanthaogorman@gmail.com',
    company: 'Thrive Pet Healthcare - Natick',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Natick',
    state: 'MA',
    country: 'US',
    postalCode: '01760',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 10:44:58 EST',
  },
  {
    id: 'vmx-2026-203',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Yui Kurakake',
    email: 'yuikurakake@gmail.com',
    company: 'Bulger Veterinary Hospital at Ethos Veterinary Health',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Billerica',
    state: 'MA',
    country: 'US',
    postalCode: '01821',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 10:45:01 EST',
  },
  {
    id: 'vmx-2026-204',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Nicholas Nohling',
    email: 'nicholas.nohling@merck.com',
    company: 'Merck Animal Health',
    role: 'Director - Animal Health Ventures',
    phone: '',
    city: 'Rahway',
    state: 'NJ',
    country: 'US',
    postalCode: '07065',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:25:02 EST',
  },
  {
    id: 'vmx-2026-205',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Mark Downing',
    email: 'drmark@floridavet.com',
    company: 'Sarasota Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Sarasota',
    state: 'FL',
    country: 'US',
    postalCode: '34233',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:31:27 EST',
  },
  {
    id: 'vmx-2026-206',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Lawrence Putter',
    email: 'lputterdvm@aol.com',
    company: 'Lenox Hill Veterinarians',
    role: 'DVM',
    phone: '',
    city: 'NY',
    state: 'NY',
    country: 'US',
    postalCode: '10065',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:54:59 EST',
  },
  {
    id: 'vmx-2026-207',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Janet Hoke',
    email: 'tym_mar_farms@hotmail.com',
    company: 'Compassion Animal Hospital',
    role: 'DVM',
    phone: '',
    city: 'Lakeland',
    state: 'FL',
    country: 'US',
    postalCode: '33810',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:55:03 EST',
  },
  {
    id: 'vmx-2026-208',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Melissa Havemann, DVM',
    email: 'havemanndvm@gmail.com',
    company: 'Compassion Veterinary Hospital, PLLC',
    role: 'Owner, DVM',
    phone: '',
    city: 'Jarrell',
    state: 'TX',
    country: 'US',
    postalCode: '76537',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:55:05 EST',
  },
  {
    id: 'vmx-2026-209',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Angel Wolfe',
    email: 'awolfe@compassionvh.com',
    company: 'Compassion Veterinary Hospital, PLLC',
    role: 'Practice Manager',
    phone: '',
    city: 'Jarrell',
    state: 'TX',
    country: 'US',
    postalCode: '76537',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:55:09 EST',
  },
  {
    id: 'vmx-2026-210',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'John Clark',
    email: 'john@vbcvc.com',
    company: 'Community Veterinary Clinic',
    role: 'Dr.',
    phone: '',
    city: 'Vero Beach',
    state: 'FL',
    country: 'US',
    postalCode: '32960',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:55:12 EST',
  },
  {
    id: 'vmx-2026-211',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Holly Evans',
    email: 'Hevans@vetcor.com',
    company: 'Countryside',
    role: 'Veterinarian',
    phone: '',
    city: 'Warren',
    state: 'OH',
    country: 'US',
    postalCode: '44483',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:55:16 EST',
  },
  {
    id: 'vmx-2026-212',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Chelsea LeMon',
    email: 'clemon@vetcor.com',
    company: 'Countryside Veterinary Service',
    role: 'RVT/Hospital Manager',
    phone: '',
    city: 'Warren',
    state: 'OH',
    country: 'US',
    postalCode: '44483',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:55:20 EST, 2026-01-19 15:51:15 EST',
  },
  {
    id: 'vmx-2026-213',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Marina Kaufmann',
    email: 'marina.s.kaufmann@gmail.com',
    company: 'Woona',
    role: 'Founder/CEO',
    phone: '',
    city: 'Amsterdam',
    state: 'NL-NH',
    country: 'NL',
    postalCode: '1071 NL',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:55:23 EST, 2026-01-19 15:51:12 EST',
  },
  {
    id: 'vmx-2026-214',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kathryn McCarty',
    email: 'mplqqs@gmail.com',
    company: 'SAGE Pet Hospital, University of Missouri',
    role: 'veterinary technician, adjunct instructor',
    phone: '',
    city: 'Asheville',
    state: 'NC',
    country: 'US',
    postalCode: '28721',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 11:57:39 EST, 2026-01-19 15:51:08 EST',
  },
  {
    id: 'vmx-2026-215',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kristine Ulitchny',
    email: 'kulitchny@hotmail.com',
    company: 'Sahara Pines Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Las Vegas',
    state: 'NV',
    country: 'US',
    postalCode: '89146',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 12:13:42 EST',
  },
  {
    id: 'vmx-2026-216',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Daniel Ulitchny',
    email: 'ulitchny@hotmail.com',
    company: 'Sahara Pines Animal Hospital',
    role: 'Medical Director',
    phone: '',
    city: 'Las Vegas',
    state: 'NV',
    country: 'US',
    postalCode: '89146',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 12:13:45 EST',
  },
  {
    id: 'vmx-2026-217',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Anastasia Conolly',
    email: 'amvvmarsh44@gmail.com',
    company: 'Arbor View Animal Hospital',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Portage',
    state: 'IN',
    country: 'US',
    postalCode: '46368',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 12:32:42 EST',
  },
  {
    id: 'vmx-2026-218',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kiera Reardon',
    email: 'k.reardondvm@gmail.com',
    company: 'Arbor View Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Hobart',
    state: 'IN',
    country: 'US',
    postalCode: '46342',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 12:32:48 EST',
  },
  {
    id: 'vmx-2026-219',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Judy Duderstadt',
    email: 'dudercat2007@yahoo.com',
    company: 'N/A',
    role: 'DVM',
    phone: '',
    city: 'Monroe',
    state: 'MI',
    country: 'US',
    postalCode: '48161',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 12:35:09 EST',
  },
  {
    id: 'vmx-2026-220',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Calvin Johnson',
    email: 'cjohnson@wpvet.net',
    company: 'Winter Park Veterinary Hospital',
    role: '',
    phone: '',
    city: 'Winter Park',
    state: 'FL',
    country: 'US',
    postalCode: '32789',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 12:37:33 EST',
  },
  {
    id: 'vmx-2026-221',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Lori White',
    email: 'lpw1968@gmail.com',
    company: 'Village Veterinary Clinic',
    role: 'veterinarian',
    phone: '',
    city: 'Athens',
    state: 'AL',
    country: 'US',
    postalCode: '35613',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 12:50:56 EST',
  },
  {
    id: 'vmx-2026-222',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kendra Doyle',
    email: 'klvest825@gmail.com',
    company: 'Lake Katrine Animal Hospital',
    role: 'Veterinary Technician',
    phone: '',
    city: 'Glasco',
    state: 'NY',
    country: 'US',
    postalCode: '12432',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 12:52:26 EST',
  },
  {
    id: 'vmx-2026-223',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jeff Head',
    email: 'jeff.head@svp.vet',
    company: 'Glade Valley Animal Hospital',
    role: 'Dr. Jeff Head',
    phone: '',
    city: 'Frederick',
    state: 'MD',
    country: 'US',
    postalCode: '21701',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 13:02:00 EST',
  },
  {
    id: 'vmx-2026-224',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Ariel Gillfillan',
    email: 'amrobelen@gmail.com',
    company: 'Willowrun Veterinary Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Raleigh',
    state: 'NC',
    country: 'US',
    postalCode: '27606',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 13:13:37 EST',
  },
  {
    id: 'vmx-2026-225',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Camila Prieto',
    email: 'cprieto@exoticbirdhospital.com',
    company: 'Exotic Bird Hospital Inc',
    role: 'Operations Manager',
    phone: '',
    city: 'Jacksonville',
    state: 'FL',
    country: 'US',
    postalCode: '32246',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 14:00:34 EST',
  },
  {
    id: 'vmx-2026-226',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jaret Keeler',
    email: 'Jaretkeeler@me.com',
    company: '',
    role: '',
    phone: '',
    city: 'Foothills',
    state: 'AB',
    country: 'CA',
    postalCode: 'T1S 5A5',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 14:07:08 EST',
  },
  {
    id: 'vmx-2026-227',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Crista Wallis',
    email: 'cristawallis@att.net',
    company: 'Monticello Animal Hospital/ Virtual Care Consultant, LLC.',
    role: 'Veterinarian',
    phone: '',
    city: 'Shawnee',
    state: 'KS',
    country: 'US',
    postalCode: '66227',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 14:22:45 EST',
  },
  {
    id: 'vmx-2026-228',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jama Souder',
    email: 'jama.souder@plymouthvetclinicin.com',
    company: 'Plymouth Vetetinary Clinic LLC',
    role: 'Owner',
    phone: '',
    city: 'Plymouth',
    state: 'IN',
    country: 'US',
    postalCode: '46563',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 14:29:03 EST',
  },
  {
    id: 'vmx-2026-229',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Ashley Miller',
    email: 'drmiller@berryhillah.com',
    company: 'Berry Hill Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Nashville',
    state: 'TN',
    country: 'US',
    postalCode: '37204',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 14:31:55 EST',
  },
  {
    id: 'vmx-2026-230',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Gabrielle Rowland',
    email: 'gabrielle.rowland@icloud.com',
    company: 'Oakview Animal Hospital',
    role: 'Dr.',
    phone: '',
    city: 'Palm Bay',
    state: 'FL',
    country: 'US',
    postalCode: '32909',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 14:44:35 EST',
  },
  {
    id: 'vmx-2026-231',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Roldano Rivera',
    email: 'rolandorivera@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: 'US',
    postalCode: '',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 14:44:39 EST',
  },
  {
    id: 'vmx-2026-232',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Alexis Ivan',
    email: 'aivan@mocs.flsouthern.edu',
    company: 'n/a',
    role: '',
    phone: '',
    city: 'naples',
    state: 'FL',
    country: 'US',
    postalCode: '34108',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 15:29:21 EST',
  },
  {
    id: 'vmx-2026-233',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kyra Hetland',
    email: 'khetland2@mocs.flsouthern.edu',
    company: 'N/A',
    role: '',
    phone: '',
    city: 'Lakeland',
    state: 'FL',
    country: 'US',
    postalCode: '33801',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 15:29:24 EST',
  },
  {
    id: 'vmx-2026-234',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Gina Hill',
    email: 'Ginavmx@gmail.com',
    company: 'Pet vet care center',
    role: 'Technician Supervisor',
    phone: '',
    city: 'ELLISVILLE',
    state: 'MS',
    country: 'US',
    postalCode: '39437',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 15:51:42 EST',
  },
  {
    id: 'vmx-2026-235',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'April Clark',
    email: 'aprilclark1211@yahoo.com',
    company: 'The pet hospitals',
    role: 'Vet tech',
    phone: '',
    city: 'Ovett',
    state: 'MS',
    country: 'US',
    postalCode: '39464',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 15:51:47 EST',
  },
  {
    id: 'vmx-2026-236',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Genevieve Heald',
    email: 'genevieve.c.heald@gmail.com',
    company: 'Alaqua Animal Refuge and Veterinary Emergency Referral Center',
    role: 'Shelter Medical Technician and Emergency Veterinary Technician',
    phone: '',
    city: 'Pensacola',
    state: 'FL',
    country: 'US',
    postalCode: '32505',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 15:55:12 EST',
  },
  {
    id: 'vmx-2026-237',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Christina Miccio',
    email: 'luvyrpet@aol.com',
    company: 'NVA All Creatures Great and Small Animal Hospital',
    role: 'DVM',
    phone: '',
    city: 'Suffern',
    state: 'NY',
    country: 'US',
    postalCode: '10901',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 16:11:46 EST',
  },
  {
    id: 'vmx-2026-238',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Marianela Ramos',
    email: 'marianelarv@yahoo.es',
    company: 'Panda animal clinic',
    role: 'Veterinarian',
    phone: '',
    city: 'Miami',
    state: 'FL',
    country: 'US',
    postalCode: '33010',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 16:31:47 EST',
  },
  {
    id: 'vmx-2026-239',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Cristian Perales',
    email: 'vetero3@hotmail.com',
    company: 'WEST MIAMI ANIMAL HOSPITAL',
    role: 'VETERINARIAN',
    phone: '',
    city: 'Miami',
    state: 'FL',
    country: 'US',
    postalCode: '33155',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 16:31:50 EST',
  },
  {
    id: 'vmx-2026-240',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Abigail Bedell',
    email: 'abbyepiz7@gmail.com',
    company: 'Nottingham Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Willingboro',
    state: 'NJ',
    country: 'US',
    postalCode: '08046',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 16:31:52 EST',
  },
  {
    id: 'vmx-2026-241',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Rachel Metz',
    email: 'rme.46732@gmail.com',
    company: 'N/A',
    role: '',
    phone: '',
    city: 'Brookpark',
    state: 'OH',
    country: 'US',
    postalCode: '44142',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 16:31:53 EST',
  },
  {
    id: 'vmx-2026-242',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Meaghan Morris',
    email: 'morris.meaghan87@gmail.com',
    company: 'Landrum Veterinary Hospital',
    role: 'Veterinary Assistant',
    phone: '',
    city: 'Landrum',
    state: 'SC',
    country: 'US',
    postalCode: '29356',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 16:43:52 EST',
  },
  {
    id: 'vmx-2026-243',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Anna June Bailey',
    email: 'aj97470@yahoo.com',
    company: 'Bailey Veterinary Clinic',
    role: 'CVT',
    phone: '',
    city: 'Roseburg',
    state: 'OR',
    country: 'US',
    postalCode: '97471',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 16:51:21 EST',
  },
  {
    id: 'vmx-2026-244',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Eduardo Arellano',
    email: 'edthevet@aol.com',
    company: 'A Family Veterinarian, PLLC',
    role: 'Owner',
    phone: '',
    city: 'Ocala',
    state: 'FL',
    country: 'US',
    postalCode: '34476',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 17:06:03 EST',
  },
  {
    id: 'vmx-2026-245',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Alexis Brill',
    email: 'alexislbrill@gmail.com',
    company: 'Boulevard Veterinary- Logan Square',
    role: 'Medical Director',
    phone: '',
    city: 'Chicago',
    state: 'IL',
    country: 'US',
    postalCode: '60610',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 17:11:57 EST',
  },
  {
    id: 'vmx-2026-246',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jenna Frank',
    email: 'frank.jenna.dvm@gmail.com',
    company: 'Pine City Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Brook Park',
    state: 'MN',
    country: 'US',
    postalCode: '55007',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 17:12:00 EST',
  },
  {
    id: 'vmx-2026-247',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Amy Schein',
    email: 'scheina@bellsouth.net',
    company: 'Homecare Veterinary Clinic',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Pennington',
    state: 'NJ',
    country: 'US',
    postalCode: '08534',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-19 17:19:28 EST',
  },
  {
    id: 'vmx-2026-248',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kathryn Stribley',
    email: 'knstribley@gmail.com',
    company: 'Texas Veterinary Hospital',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'San Antonio',
    state: 'TX',
    country: 'US',
    postalCode: '78254',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 10:12:44 EST',
  },
  {
    id: 'vmx-2026-249',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Graham Smith',
    email: 'graham.mccann.smith@gmail.com',
    company: 'Goldsboro Veterinary Hospital',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Clayton',
    state: 'NC',
    country: 'US',
    postalCode: '27520',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 10:22:24 EST, 2026-01-20 10:22:32 EST',
  },
  {
    id: 'vmx-2026-250',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Amber Kossol',
    email: 'stickelfish20@yahoo.com',
    company: 'Clay Humane',
    role: 'Veterinarian',
    phone: '',
    city: 'Jacksonville',
    state: 'FL',
    country: 'US',
    postalCode: '32223',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 10:22:29 EST',
  },
  {
    id: 'vmx-2026-251',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Courtney Lewis',
    email: 'drlewis@chatt.vet',
    company: 'Chatt-Town Veterinary Care',
    role: 'Veterinarian/owner',
    phone: '',
    city: 'Chattanooga',
    state: 'TN',
    country: 'US',
    postalCode: '37415',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 10:26:43 EST',
  },
  {
    id: 'vmx-2026-252',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Scott Whiteman',
    email: 'swhiteman9930@gmail.com',
    company: 'Willow Wood Animal Hospital, Inc',
    role: 'Veterinarian',
    phone: '16148553855',
    city: 'New Albany',
    state: 'OH',
    country: 'US',
    postalCode: '43054',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 10:32:28 EST',
  },
  {
    id: 'vmx-2026-253',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Colleen Lambo',
    email: 'travellingvet@gmail.com',
    company: 'Roo',
    role: 'DVM',
    phone: '',
    city: 'San Francisco',
    state: 'CA',
    country: 'US',
    postalCode: '94111',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 10:39:52 EST',
  },
  {
    id: 'vmx-2026-254',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Caitlin Peterson',
    email: 'caitlindvm@gmail.com',
    company: 'Prairie Creek Pet Hospital P.C.',
    role: '',
    phone: '',
    city: 'Sioux Falls',
    state: 'SD',
    country: 'US',
    postalCode: '57104',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 10:45:57 EST',
  },
  {
    id: 'vmx-2026-255',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Bristol Woods',
    email: 'chryhumm@gmail.com',
    company: 'Wallenpaupack Veterinary Clinic',
    role: '',
    phone: '',
    city: 'Hawley',
    state: 'PA',
    country: 'US',
    postalCode: '18431',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 10:50:35 EST',
  },
  {
    id: 'vmx-2026-256',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Courtney Gilmore',
    email: 'courtney.gilmore.dvm@gmail.com',
    company: 'Town and Country Veterinary Hospital',
    role: 'Associate Veterinarian',
    phone: '6362277387',
    city: "O'fallon",
    state: 'MO',
    country: 'US',
    postalCode: '63366',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 10:56:38 EST',
  },
  {
    id: 'vmx-2026-257',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Mark Colgin',
    email: 'mark.colgin@ceva.com',
    company: 'Ceva Animal Health',
    role: 'Alliance Manager',
    phone: '913-608-2990',
    city: 'Lenexa',
    state: 'KS',
    country: 'US',
    postalCode: '66213',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 11:06:15 EST',
  },
  {
    id: 'vmx-2026-258',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Joseph Araujo',
    email: 'josepha@intervivo.com',
    company: 'Transpharmation Ltd',
    role: 'Chief Corporate Development Officer',
    phone: '',
    city: 'Fergus',
    state: 'ON',
    country: 'CA',
    postalCode: 'N1m2w8',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 11:12:09 EST, 2026-01-20 11:13:54 EST',
  },
  {
    id: 'vmx-2026-259',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Katherine Carron Lilly',
    email: 'drkcarron@amcwyoming.com',
    company: 'Animal Medical Center of Wyoming',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Byron Center',
    state: 'MI',
    country: 'US',
    postalCode: '49315',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 11:25:47 EST',
  },
  {
    id: 'vmx-2026-260',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jennifer Gallo',
    email: 'jennifer.gallo@snevc.com',
    company: 'Southern New England Veterinary Care',
    role: 'Veterinarian',
    phone: '',
    city: 'Uxbridge',
    state: 'MA',
    country: 'US',
    postalCode: '01569',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 11:43:24 EST',
  },
  {
    id: 'vmx-2026-261',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Mark Morrison',
    email: 'markm@cvcboca.com',
    company: 'Calusa Veterinary Center',
    role: 'Hospital Administrator',
    phone: '',
    city: 'Boca Raton',
    state: 'FL',
    country: 'US',
    postalCode: '33487',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 11:49:07 EST',
  },
  {
    id: 'vmx-2026-262',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Ginger Bryant Hutchinson',
    email: 'gvhpetdocs@yahoo.com',
    company: 'Glencoe Veterinary Hospital',
    role: 'Veterinarian/Owner',
    phone: '',
    city: 'New Smyrna Beach',
    state: 'FL',
    country: 'US',
    postalCode: '32169',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 11:49:10 EST',
  },
  {
    id: 'vmx-2026-263',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Cherie Sanders',
    email: 'cnardino@yahoo.com',
    company: 'Glencoe Veterinary Hospital',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'Decatur',
    state: 'AL',
    country: 'US',
    postalCode: '35603',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 11:49:13 EST',
  },
  {
    id: 'vmx-2026-264',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Austin Coull',
    email: 'austin.coull@thrivepet.com',
    company: 'Thrive Pet Healthcare',
    role: 'Associate Veterinarian',
    phone: '',
    city: 'San Antonio',
    state: 'TX',
    country: 'US',
    postalCode: '78261',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 12:07:35 EST',
  },
  {
    id: 'vmx-2026-265',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Logan Kopp',
    email: 'dvm@logankopp.com',
    company: 'Priest Lake Veterinary Hospital',
    role: 'Board Certified Exotic Companion Mammal Specialist',
    phone: '',
    city: 'Antioch',
    state: 'TN',
    country: 'US',
    postalCode: '37013',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 12:57:10 EST',
  },
  {
    id: 'vmx-2026-266',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Joanne Kamper',
    email: 'jokamper@gmail.com',
    company: 'Andover Animal Hospital',
    role: 'Veterinarian',
    phone: '',
    city: 'Brooklyn Park',
    state: 'MN',
    country: 'US',
    postalCode: '55445',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 13:41:52 EST',
  },
  {
    id: 'vmx-2026-267',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Kari Wittmer',
    email: 'karevet@gmail.com',
    company: 'N/A',
    role: '',
    phone: '',
    city: 'Blaine',
    state: 'MN',
    country: 'US',
    postalCode: '55449',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 13:41:55 EST',
  },
  {
    id: 'vmx-2026-268',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Michael Guastini',
    email: 'michael@woodstock.vet',
    company: 'Woodstock Veterinary Clinic',
    role: 'TopDog',
    phone: '',
    city: 'Killingly',
    state: 'CT',
    country: 'US',
    postalCode: '06239',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 13:43:39 EST',
  },
  {
    id: 'vmx-2026-269',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Joshua Chelgren',
    email: 'chelgren.josh@gmail.com',
    company: 'BANFIELD',
    role: 'Veterinarian',
    phone: '',
    city: 'Huntersville',
    state: 'NC',
    country: 'US',
    postalCode: '28078',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 13:57:10 EST',
  },
  {
    id: 'vmx-2026-270',
    eventKey: 'vmx-2026',
    eventName: 'VMX 2026',
    sourceFile: 'vmx.xlsx',
    fullName: 'Jose Manuel Leotaud',
    email: 'jmleotaud@gmail.com',
    company: 'SEVC (Southern European Veterinary Conference)',
    role: 'exhibitor',
    phone: '',
    city: 'orlando',
    state: 'FL',
    country: 'US',
    postalCode: '32820',
    ticketType: '',
    context: 'Adapet',
    notes: '',
    scannedAt: '2026-01-20 13:59:55 EST',
  },
  {
    id: 'wvc-2026-1',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Diane Baumgartner',
    email: 'dbaumgartner@nva.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-2',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Maggie Burnworth',
    email: 'maggie.burnworth@nemacolin.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-3',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Timothy Cox',
    email: 'cox3070@bellsouth.net',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-4',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Siggi Farris',
    email: 'dr.farris@riverrunah.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-5',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Karen Fidell',
    email: 'kfidell@ovrs.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-6',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Bruce Frey',
    email: 'freypad@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-7',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Mary Grabow',
    email: 'mary.grabow@vsecindy.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-8',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Amanda Hartman',
    email: 'whitehallanimalclinic@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-9',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Suzy Heard',
    email: 'brheard01@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-10',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jodi Hofer',
    email: 'Hofer.ny@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-11',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Michelle Immel',
    email: 'Mimmel@vetcor.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-12',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Angel Martin',
    email: 'angel@mygavet.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-13',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Morgan Matlack',
    email: 'morganmatlack333@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-14',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Marie-Victorine McKeown',
    email: 'marievictorine@icloud.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-15',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Mena Melek',
    email: 'mena.g.melek@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-16',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Brad Miller',
    email: 'drmiller@mygavet.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-17',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Kara Mitchell',
    email: 'karamf78@hotmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-18',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Kaori O’Neill',
    email: 'Kaori.oneill@vca.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-19',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Dawn Schmidt',
    email: 'drenfrow0325@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-20',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Manjit Singh',
    email: 'manjitahuja12@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-21',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Kelsee Stoner',
    email: 'kelseestoner@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-22',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Fran Woodworth',
    email: 'fgwdvm@me.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'dustin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-23',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Victor .',
    email: 'hospvetdrserna1@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-24',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jose AFornogudelo',
    email: 'Johnsan0379@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-25',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Moriah Berthrong',
    email: 'mrberthrong@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-26',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Karen Bond',
    email: 'karen.bond@dechra.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-27',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Robert Buchholz',
    email: 'robert.buchholz@banfield.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-28',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Mary Pride Clark',
    email: 'mpclark6@duck.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-29',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Mallory Dickinson',
    email: 'malhnpe@aol.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-30',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Lauren Filicia',
    email: 'l.filicia@closerstillmedia.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-31',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Connie Ganter',
    email: 'connieganter@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-32',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Connie Ganter',
    email: 'connieganter@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-33',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Iris Gilad',
    email: 'irisgilad@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-34',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Megan Grobman',
    email: 'megrobma@ncsu.edu',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-35',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Keith Jasinski',
    email: 'keithj@maianimalhealth.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-36',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Deborah Langford',
    email: 'langford.deborah@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-37',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jackeline Maguiña',
    email: 'jsmaguinap@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-38',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Balpal Sandhu',
    email: 'sandhudvm@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-39',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Thomas Schermerhorn',
    email: 'tscherme@vet.k-state.edu',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-40',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jeff Vitullo',
    email: 'jeff.vitullo@milaint.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-41',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jacob Straube',
    email: 'jacob@withorbital.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'marcus@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-42',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Gershon Alaluf',
    email: 'doctorgisme@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-43',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Eduardo Alfaro',
    email: 'ealfaro2014@aichs.org',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-44',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Katherine Ashdown',
    email: 'kskywalkr@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-45',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Satwinder Bajwa',
    email: 'bajwasatwinder@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-46',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Satwinder Bajwa',
    email: 'bajwasatwinder@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-47',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jonathan Baker',
    email: 'Jonathanbakerdvm@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-48',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jacobo Balairon',
    email: 'jbalairon@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-49',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Pavittar Bassi',
    email: 'pets911@hotmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-50',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Janet Behm',
    email: 'janet.behm@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-51',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Alex Berthrong',
    email: 'afberthrong@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-52',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Cynthia Binder',
    email: 'Binderhaus@aol.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-53',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Caitlin Blackburn',
    email: 'cblackburn@stockdocvet.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-54',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Alisa Brossoit',
    email: 'AlisaBrossoit@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-55',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Rachel Brown',
    email: 'rachioann@comcast.net',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-56',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Amanda Bugarovich',
    email: 'amandabugarovich@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-57',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Stephanie Burbach',
    email: 'stephanieburbach43@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-58',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Dominic Cacioppo',
    email: 'birdofpreylv@aol.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-59',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Melissa Call',
    email: 'melbeck_98@hotmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-60',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Heather Cameron',
    email: 'heather@cadeyrn.us',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-61',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Brandy Cameron',
    email: 'brandy.cameron232@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-62',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Celina Cisneros',
    email: 'celinacisneros613@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-63',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Mary Pride Clark',
    email: 'mpclark6@duck.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-64',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Katherine Cline',
    email: 'kscline09@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-65',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Tawnya Copland',
    email: 't.copland@usask.ca',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-66',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'ELENA COSAREANU',
    email: 'elena_cosareanu@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-67',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Laura Coughlin',
    email: 'lauraleecoughlin@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-68',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Laura Covert',
    email: 'lollybear9@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-69',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Dayra Delgado',
    email: 'dayra.delgado15@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-70',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Balwinder Dhaliwal',
    email: 'caec911@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-71',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jaison Dhaliwal',
    email: 'jaison.dhaliwal@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-72',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Aspen Dornburg',
    email: 'aspenareal@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-73',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Cindy Duff',
    email: 'cindydewiduff@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-74',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Tani Erickson',
    email: 'tanierickson@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-75',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Dawn Evert',
    email: 'drevert@clauspaws.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-76',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Markos Farag',
    email: 'markos.magdy@ymail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-77',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Ashlyn Fergie',
    email: 'afergie92@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-78',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jennifer Finder',
    email: 'jfinder87@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-79',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'ELLEN GERMAN',
    email: 'ELLENGERMAN17@GMAIL.COM',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-80',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Angeline Gerolaga',
    email: 'angeline0100@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-81',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Robin Gilbertson',
    email: 'robingilbertson@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-82',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Parker Gladhart-Wells',
    email: 'pgladhartwells@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-83',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Theresa Goldsmith',
    email: 'Terriegoldsmith19@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-84',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Kassandra Gonzalez',
    email: 'kassandra.gonzalezdvm@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-85',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jamie Harmon',
    email: 'jamie.harmon@nva.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-86',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Shannon Hill',
    email: 'shannon.hill@fhah.ca',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-87',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Terry Honer',
    email: 'dvmrelief@aol.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-88',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Erika Hultquist',
    email: 'erika@bvspets.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-89',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Erika Hultquist',
    email: 'erika@bvspets.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-90',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'James Israelsen',
    email: 'drjei@comcast.net',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-91',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Laura Jacobson',
    email: 'Jacobson_dvm@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-92',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Tamara Jameson',
    email: 'tamara.jameson@fhah.ca',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-93',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'TIA JENKINS',
    email: 'tia@bvspets.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-94',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Julie Jennings',
    email: 'julie@castlerockpetdoc.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-95',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Randy Kaler',
    email: 'randykalerdvm@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-96',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Katrina Kucera',
    email: 'dvmkatrina@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-97',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Lorna Lanman',
    email: 'lldvmnaz@aol.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-98',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Laura Little',
    email: 'l.little@live.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-99',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Allison Luecking',
    email: 'allison.luecking@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-100',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Diana Luu',
    email: 'dianaluu8694@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-101',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Natalie Magallanes',
    email: 'nmagdvm@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-102',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Leona Martin',
    email: 'amerisci@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-103',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Camille Martinez',
    email: 'cam.martinezf@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-104',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Colleen McCarthy',
    email: 'c.mccarthy2012@icloud.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-105',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Autumn McKay',
    email: 'mckay.autumn@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-106',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Carolina Moncada',
    email: 'moncadacharlie3@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-107',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Reid Moorhead',
    email: 'rmoorhead9178@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-108',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Erica Nash',
    email: 'erican@lmah.net',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-109',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jenny Orr',
    email: 'platapuss6767@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-110',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Brandy Osburn',
    email: 'rvttogo@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-111',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Victor Parra',
    email: 'victorparram@hotmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-112',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Cynthia Peralo',
    email: 'cynthiaperalo@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-113',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Rachel Pruitt',
    email: 'rachel.pruitt@vca.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-114',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Illiana Quimbaya',
    email: 'drq@vipvetseattle.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-115',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Marissa Razo',
    email: 'marissarazo3@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-116',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Daniela Reagan',
    email: 'dfreagan@hotmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-117',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Whitney Refvem',
    email: 'wprefvem@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-118',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Adam Riley',
    email: 'ariley02@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-119',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Carolyn Robbins',
    email: 'cbrobbins@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-120',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Lillian Roberts',
    email: 'Andidvm@aol.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-121',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Coral Rodriguez',
    email: 'coral@vipvetseattle.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-122',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Cheryl Roth',
    email: 'drcroth@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-123',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Dawn Schroeder',
    email: 'dawn.s@marinavillagevet.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-124',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Kuldeip Sekhon',
    email: 'sekhonk2001@yahoo.ca',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-125',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Laura Shaw',
    email: 'Civicdraging@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-126',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Arthur Snowden III',
    email: 'neilan_snowden@hotmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-127',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jatain Sondhi',
    email: 'vet.drsondhi@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-128',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Dave Statner',
    email: 'dave@primaryvetcare.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-129',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Jana Sulenes',
    email: 'Janasulenes@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-130',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Cariann Turbeville',
    email: 'cariann@airvet.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-131',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Martha Ullman',
    email: 'maudvm09@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-132',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Kathleen Urquidi',
    email: 'muscat6840@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-133',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Brady VanderLind',
    email: 'bvanderlind@msn.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-134',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Tracy Wachbrit',
    email: 'wachbrit.tracy@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-135',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Corrie Walters',
    email: 'corrie.walters@nva.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-136',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Ilan Waskow',
    email: 'ilanwaskow@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-137',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Paige White',
    email: 'paige_m_white@outlook.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-138',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Breanna Wild',
    email: 'bwild@heritage.vet',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'wvc-2026-139',
    eventKey: 'wvc-2026',
    eventName: 'WVC 2026',
    sourceFile: 'WVC.xlsx',
    fullName: 'Robin Zimmerman',
    email: 'drrrayz@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: '',
    context: 'quintin@adapetmedical.com',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-booth-2026-1',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Rebecca Soules',
    email: 'rg.lvt@yahoo.com',
    company: 'Moravia Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '3154367014',
    city: 'Auburn',
    state: 'New York',
    country: 'United States of America',
    postalCode: '13021',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:04:07',
  },
  {
    id: 'fetch-charlotte-booth-2026-2',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Catherine Markijohn',
    email: 'corgidoc595@gmail.com',
    company: 'Harris Boulevard Veterinary Clinic',
    role: 'Veterinarian',
    phone: '9197210560',
    city: 'Concord',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28027',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:04:14',
  },
  {
    id: 'fetch-charlotte-booth-2026-3',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Sarah Olsen',
    email: 'drasarahvet@gmail.com',
    company: 'University of Glasgow / Currently self employed relief',
    role: 'Veterinarian',
    phone: '7868063168',
    city: 'Warner Robins',
    state: 'Georgia',
    country: 'United States of America',
    postalCode: '31093',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:12:32',
  },
  {
    id: 'fetch-charlotte-booth-2026-4',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Melody Nelson',
    email: 'mellvt90@gmail.com',
    company: 'Granby Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '7578060726',
    city: 'Chesapeake',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '23325',
    ticketType: 'Hospital Staff',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:27:24',
  },
  {
    id: 'fetch-charlotte-booth-2026-5',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Dia Young',
    email: 'dasian@gmail.com',
    company: 'VEG',
    role: 'Veterinary Technician',
    phone: '8283350974',
    city: 'Kyle',
    state: 'Texas',
    country: 'United States of America',
    postalCode: '78640',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:36:43',
  },
  {
    id: 'fetch-charlotte-booth-2026-6',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: "Cecille O'Brien Greenleaf",
    email: 'caogreenleaf@gmail.com',
    company: 'Veterinary HouseCalls',
    role: 'Veterinarian',
    phone: '6505330074',
    city: 'San jose',
    state: 'California',
    country: 'United States of America',
    postalCode: '95129',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:43:25',
  },
  {
    id: 'fetch-charlotte-booth-2026-7',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Andrea Varney',
    email: 'andreavarney22@gmail.com',
    company: 'Spay Neuter Veterinary Clinic',
    role: 'Veterinary Technician',
    phone: '8038479480',
    city: 'Fayetteville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28314',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:45:43',
  },
  {
    id: 'fetch-charlotte-booth-2026-8',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Carolina Stein',
    email: 'carolsasse@gmail.com',
    company: 'Wholepet - Mission pet health',
    role: 'Veterinary Technician',
    phone: '7044411089',
    city: 'Lancaster',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29720',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:47:29',
  },
  {
    id: 'fetch-charlotte-booth-2026-9',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Ama Cole',
    email: 'ama.cole.miller@gmail.com',
    company: 'FACE',
    role: 'Veterinarian',
    phone: '3173195081',
    city: 'Brownsburg',
    state: 'Indiana',
    country: '',
    postalCode: '46112',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:50:46',
  },
  {
    id: 'fetch-charlotte-booth-2026-10',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Diane Vermillion',
    email: 'dvermillion411@gmail.com',
    company: 'Main Street Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '7043101014',
    city: 'Cornelius',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28031',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:54:59',
  },
  {
    id: 'fetch-charlotte-booth-2026-11',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Amy Toy',
    email: 'amy.toy@thrivepet.com',
    company: 'Massapequa Hospital for Animals',
    role: 'Veterinary Technician',
    phone: '5087359351',
    city: 'East Meadow',
    state: 'New York',
    country: 'United States of America',
    postalCode: '11554',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T08:58:09',
  },
  {
    id: 'fetch-charlotte-booth-2026-12',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Nikita Hudgins',
    email: 'nikitahudginslvmt@gmail.com',
    company: 'Belmont Animal Hospital',
    role: 'Veterinary Technician',
    phone: '9319948915',
    city: 'Centerville',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37033',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:02:18',
  },
  {
    id: 'fetch-charlotte-booth-2026-13',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Sam Schopler',
    email: 'samuelschopler@gmail.com',
    company: '.',
    role: 'Veterinarian',
    phone: '9193570298',
    city: 'Raleigh',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27606',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:07:43',
  },
  {
    id: 'fetch-charlotte-booth-2026-14',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Sonia Borrell',
    email: 'smborrell@gmail.com',
    company: 'Sun Valley Animal Hospital',
    role: 'Veterinarian',
    phone: '9195201842',
    city: 'Unionville',
    state: 'North Carolina',
    country: '',
    postalCode: '28110',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:23:57',
  },
  {
    id: 'fetch-charlotte-booth-2026-15',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Heather Johnson',
    email: 'heather.johnson087@yahoo.com',
    company: 'SVP',
    role: 'Veterinary Technician',
    phone: '5188219404',
    city: 'Monroe',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28110',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:24:03',
  },
  {
    id: 'fetch-charlotte-booth-2026-16',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Christi Mcpherson',
    email: 'cnmcpher@aggies.ncat.edu',
    company: 'Creekside Animal Clinic',
    role: 'Hospital Staff',
    phone: '3365139960',
    city: 'Mebane',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27302',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:30:59',
  },
  {
    id: 'fetch-charlotte-booth-2026-17',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Vanessa Straehle',
    email: 'vanessa@mycreeksideonline.com',
    company: 'CREEKSIDE ANIMAL CLINIC',
    role: 'Hospital Staff',
    phone: '3365881952',
    city: 'Mebane',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27302',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:31:03',
  },
  {
    id: 'fetch-charlotte-booth-2026-18',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Melody Snipes',
    email: 'melody@mycreeksideonline.com',
    company: 'Creekside',
    role: 'Veterinary Technician',
    phone: '336-686-6705',
    city: 'Burlington',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27215',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:31:10',
  },
  {
    id: 'fetch-charlotte-booth-2026-19',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Aisha Voges',
    email: 'aisha.voges@totalbondvets.com',
    company: 'Totalbond Veterinary Hospitals',
    role: 'Veterinary Technician',
    phone: '8034879390',
    city: 'GASTONIA',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28056',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:43:11',
  },
  {
    id: 'fetch-charlotte-booth-2026-20',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Victoria Martin',
    email: 'victoria.martin@totalbondvets.com',
    company: 'Totalbond Veterinary Hospitals',
    role: 'Veterinary Technician',
    phone: '8284552871',
    city: 'GASTONIA',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28056',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:43:16',
  },
  {
    id: 'fetch-charlotte-booth-2026-21',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Megan Danner',
    email: 'megan.danner@totalbondvets.com',
    company: 'Totalbond Veterinary Hospitals',
    role: 'Veterinary Technician',
    phone: '7048308871',
    city: 'Gastonia',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28054',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T09:43:20',
  },
  {
    id: 'fetch-charlotte-booth-2026-22',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Paige Slater',
    email: 'slater_paige@yahoo.com',
    company: 'Casselton Veterinary Service Inc.',
    role: 'Veterinary Technician',
    phone: '7016302672',
    city: 'Fargo',
    state: 'North Dakota',
    country: 'United States of America',
    postalCode: '58103',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T10:07:01',
  },
  {
    id: 'fetch-charlotte-booth-2026-23',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Stacy VanderEyk',
    email: 'slvandy@yahoo.com',
    company: 'Orchard Lake Animal Hospital',
    role: 'Veterinary Technician',
    phone: '2484174854',
    city: 'Southfield',
    state: 'Michigan',
    country: 'United States of America',
    postalCode: '48076',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T10:14:28',
  },
  {
    id: 'fetch-charlotte-booth-2026-24',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Nicole Defibaugh',
    email: 'nkulp29@gmail.com',
    company: 'Exeter Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '215-290-9165',
    city: 'Reading',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '19606',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T10:17:01',
  },
  {
    id: 'fetch-charlotte-booth-2026-25',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Amy Tellez',
    email: 'naturalpetvcc@gmail.com',
    company: 'Natural Pet Veterinary Care',
    role: 'Veterinarian',
    phone: '704-975-4388',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28215',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T10:25:24',
  },
  {
    id: 'fetch-charlotte-booth-2026-26',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Lauren LeFebre',
    email: 'lauren.r.lefebre@gmail.com',
    company: 'East Ventura Anima Hospital',
    role: 'Veterinarian',
    phone: '8053001035',
    city: 'Ventura',
    state: 'California',
    country: 'United States of America',
    postalCode: '93004',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T10:33:34',
  },
  {
    id: 'fetch-charlotte-booth-2026-27',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Megan Garvey',
    email: 'meggie.garvey@gmail.com',
    company: 'Hanover Park Animal Care Center',
    role: 'Veterinarian',
    phone: '6303733172',
    city: 'Hanover Park',
    state: 'Illinois',
    country: 'United States of America',
    postalCode: '60133',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T10:37:17',
  },
  {
    id: 'fetch-charlotte-booth-2026-28',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Keri Craft',
    email: 'kcraft419@gmail.com',
    company: 'Hanging Rock Animal Hospital',
    role: 'Veterinary Technician',
    phone: '5405298327',
    city: 'Roanoke',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '24018',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T10:40:17',
  },
  {
    id: 'fetch-charlotte-booth-2026-29',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Sheila Hanby',
    email: 'sbh@capesideah.com',
    company: 'Capeside Animal Hospital',
    role: 'Veterinarian',
    phone: '9104310120',
    city: 'WILMINGTON',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28411',
    ticketType: 'Owner/Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T10:42:48',
  },
  {
    id: 'fetch-charlotte-booth-2026-30',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Rhonda Greene',
    email: 'rhondagreene@bellsouth.net',
    company: 'Capeside Animal Hospital',
    role: 'Veterinarian',
    phone: '9192648849',
    city: 'Belville',
    state: 'NC',
    country: '',
    postalCode: '28451',
    ticketType: 'GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T10:42:57',
  },
  {
    id: 'fetch-charlotte-booth-2026-31',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Cheryl Sine',
    email: 'csine@shandonwood.com',
    company: 'Shandon-Wood Animal Clinic',
    role: 'Veterinarian',
    phone: '678-877-0409',
    city: 'Columbia',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29205',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T11:02:40',
  },
  {
    id: 'fetch-charlotte-booth-2026-32',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Amber Hart',
    email: 'amber.r.hart.vts@gmail.com',
    company: 'MedVet Cincinnati',
    role: '',
    phone: '859-322-9536',
    city: 'Burlington',
    state: 'KY',
    country: '',
    postalCode: '',
    ticketType: 'Faculty',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T11:38:11',
  },
  {
    id: 'fetch-charlotte-booth-2026-33',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Amber Shanks',
    email: 'amber.shanks@vca.com',
    company: 'VCA',
    role: 'Veterinary Technician',
    phone: '5132354224',
    city: 'Cincinnati',
    state: 'Ohio',
    country: 'United States of America',
    postalCode: '45211',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T11:38:16',
  },
  {
    id: 'fetch-charlotte-booth-2026-34',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'David Eldridge',
    email: 'deldridge42@gmail.com',
    company: 'The Pet Hospitals - Germantown',
    role: 'Practice Manager',
    phone: '9014854856',
    city: 'Cordova',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '38018',
    ticketType: 'Practice Manager',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T11:44:29',
  },
  {
    id: 'fetch-charlotte-booth-2026-35',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Katelyn Sharpe',
    email: 'kas265@cornell.edu',
    company: 'Schoharie Valley Veterinary Clinic',
    role: 'Veterinarian',
    phone: '5188136260',
    city: 'Schoharie',
    state: 'New York',
    country: 'United States of America',
    postalCode: '12157',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T11:59:10',
  },
  {
    id: 'fetch-charlotte-booth-2026-36',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Amy Bush',
    email: 'ahava1779@gmail.com',
    company: 'Charlotte Animal Referral and Emergency',
    role: 'Veterinary Technician',
    phone: '3256688991',
    city: 'Mooresville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28117',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:03:29',
  },
  {
    id: 'fetch-charlotte-booth-2026-37',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Brittany Simpson',
    email: 'bsimpson@pagepointnc.com',
    company: 'Page Point Animal Hospital',
    role: 'Veterinarian',
    phone: '9198863097',
    city: 'Durham',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27703',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:14:12',
  },
  {
    id: 'fetch-charlotte-booth-2026-38',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Mary Van Kooy',
    email: 'mvk@eastoakvet.com',
    company: 'East Oak Animal Hospital',
    role: 'Owner',
    phone: '856-889-8286',
    city: 'Franklinville',
    state: 'New Jersey',
    country: 'United States of America',
    postalCode: '08322',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:21:53',
  },
  {
    id: 'fetch-charlotte-booth-2026-39',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Haley Norton',
    email: 'haleynorton2314@gmail.com',
    company: 'Friendship Animal Hospital',
    role: 'Practice Manager',
    phone: '9109952011',
    city: 'Pineville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28134',
    ticketType: 'Practice Manager',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:26:38',
  },
  {
    id: 'fetch-charlotte-booth-2026-40',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Jamila McKenzie',
    email: 'milajmckenzie@gmail.com',
    company: 'Banfield',
    role: 'Veterinarian',
    phone: '5163694251',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28269',
    ticketType: 'GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:30:22',
  },
  {
    id: 'fetch-charlotte-booth-2026-41',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'kathryn garcia',
    email: 'katiengarcia@gmail.com',
    company: 'Epct',
    role: 'Veterinarian',
    phone: '8329867383',
    city: 'spring',
    state: 'Texas',
    country: 'United States of America',
    postalCode: '77354',
    ticketType: 'GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:30:29',
  },
  {
    id: 'fetch-charlotte-booth-2026-42',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kelly Hodson',
    email: 'kawestfall@gmail.com',
    company: 'Urgent Pet Care',
    role: 'Owner',
    phone: '4029602531',
    city: 'Omaha',
    state: 'Nebraska',
    country: 'United States of America',
    postalCode: '68130',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:35:58',
  },
  {
    id: 'fetch-charlotte-booth-2026-43',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Greg Hill',
    email: 'gregory.hill@nva.com',
    company: 'NVA-Appalachian New River Veterinary Hospital',
    role: 'Hospital Staff',
    phone: '8287732900',
    city: 'Boone',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28607',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:36:04',
  },
  {
    id: 'fetch-charlotte-booth-2026-44',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Rachel Bowles',
    email: 'dr.bowles@riverrunah.com',
    company: 'River Run Animal Hospital',
    role: 'Veterinarian',
    phone: '8324722435',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28278',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:36:12',
  },
  {
    id: 'fetch-charlotte-booth-2026-45',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Rachel Wilson',
    email: 'rachelk.wilson@outlook.com',
    company: 'GoodVets Plaza Midwood',
    role: 'Veterinarian',
    phone: '7402529920',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28205',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:41:10',
  },
  {
    id: 'fetch-charlotte-booth-2026-46',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: "Sarah D'Amelio",
    email: 'snshishdvm@gmail.com',
    company: 'South Point Pet Hospital',
    role: 'Veterinarian',
    phone: '7039659318',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:41:15',
  },
  {
    id: 'fetch-charlotte-booth-2026-47',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Samantha Reed',
    email: 'samantha.reed@bluepearlvet.com',
    company: 'Blue Pearl LKN (Denver Animal Emergency)',
    role: 'Veterinary Technician',
    phone: '4342034654',
    city: 'Dallas',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28034',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:41:20',
  },
  {
    id: 'fetch-charlotte-booth-2026-48',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Janise Livengood',
    email: 'janiselivengood@gmail.com',
    company: 'Banfield Pet Hospital',
    role: 'Veterinary Technician',
    phone: '7042016518',
    city: 'Salisbury',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28146',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:45:34',
  },
  {
    id: 'fetch-charlotte-booth-2026-49',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Laura McDaniel',
    email: 'graney.laura@gmail.com',
    company: 'Banfield',
    role: 'Veterinary Technician',
    phone: '704-640-6554',
    city: 'Rockwell',
    state: 'NC',
    country: '',
    postalCode: '28138',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:45:39',
  },
  {
    id: 'fetch-charlotte-booth-2026-50',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Margaret Mann',
    email: 'greta.keister@gmail.com',
    company: 'Kohn Animal Hospital',
    role: 'Owner',
    phone: '8479759092',
    city: 'Northbrook',
    state: 'Illinois',
    country: 'United States of America',
    postalCode: '60062',
    ticketType: 'Owner/Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:45:44',
  },
  {
    id: 'fetch-charlotte-booth-2026-51',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kristi Sharpe',
    email: 'dr.kristisharpe@gmail.com',
    company: 'Rocky Hill Animal Hospital',
    role: 'Veterinarian',
    phone: '4232152271',
    city: 'Knoxville',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37919',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:50:22',
  },
  {
    id: 'fetch-charlotte-booth-2026-52',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kelsie Smith',
    email: 'kelsieandjosh@gmail.com',
    company: 'Rocky Hill Animal Hospital',
    role: 'Veterinary Technician',
    phone: '8658095984',
    city: 'Knoxville',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37919',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:50:26',
  },
  {
    id: 'fetch-charlotte-booth-2026-53',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Melana Martens',
    email: 'melanab@yahoo.com',
    company: 'East Maryland Animal Hospital NVA',
    role: 'Veterinarian',
    phone: '6024184454',
    city: 'Phoenix',
    state: 'Arizona',
    country: 'United States of America',
    postalCode: '85012',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T12:54:27',
  },
  {
    id: 'fetch-charlotte-booth-2026-54',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kelly Baete',
    email: 'kellybaete77@gmail.com',
    company: 'Baxter Veterinary Clinic',
    role: 'Veterinarian',
    phone: '7047785789',
    city: 'Tega Cay',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29708',
    ticketType: 'GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T13:07:38',
  },
  {
    id: 'fetch-charlotte-booth-2026-55',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Alexandra Mahn',
    email: 'drlexie@thehealthypetvet.com',
    company: 'The Healthy Pet Veterinary Clinic',
    role: 'Veterinarian',
    phone: '4043234924',
    city: 'McDonough',
    state: 'Georgia',
    country: 'United States of America',
    postalCode: '30253',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T13:09:54',
  },
  {
    id: 'fetch-charlotte-booth-2026-56',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Michelle Thrasher',
    email: 'michellethrasher68@gmail.com',
    company: 'Portland Veterinary Service',
    role: 'Practice Manager',
    phone: '517-526-5700',
    city: 'Portland',
    state: 'Michigan',
    country: 'United States of America',
    postalCode: '48875',
    ticketType: 'Practice Manager',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T13:19:09',
  },
  {
    id: 'fetch-charlotte-booth-2026-57',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Meredith Estrich',
    email: 'mfestrich@yahoo.com',
    company: 'Animal Ark Veterinary Hospital',
    role: 'Veterinarian',
    phone: '814-573-3504',
    city: 'Erie',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '16505',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T15:42:44',
  },
  {
    id: 'fetch-charlotte-booth-2026-58',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Sharon Mason',
    email: 'sharon.mason.dvm.phd@gmail.com',
    company: 'Banfield',
    role: 'Veterinarian',
    phone: '9196495082',
    city: 'Sanford',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27332',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T15:44:33',
  },
  {
    id: 'fetch-charlotte-booth-2026-59',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Cate Gately-Dean',
    email: 'categately-deandvm@verizon.net',
    company: 'Greater South River Animal Hospital',
    role: 'Veterinarian',
    phone: '4109564500',
    city: 'Edgewater',
    state: 'Maryland',
    country: 'United States of America',
    postalCode: '21037',
    ticketType: 'Owner/Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T15:52:53',
  },
  {
    id: 'fetch-charlotte-booth-2026-60',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Alyssa Reist',
    email: 'reista@appstate.edu',
    company: 'Spay Neuter Clinic of the Carolinas',
    role: 'Student',
    phone: '3096697518',
    city: 'Monroe',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28110',
    ticketType: 'Student',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T16:02:10',
  },
  {
    id: 'fetch-charlotte-booth-2026-61',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Carli Williams',
    email: 'carliwilliams93@gmail.com',
    company: 'Relief Veterinarian',
    role: 'Veterinarian',
    phone: '9103402844',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28215',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T16:02:16',
  },
  {
    id: 'fetch-charlotte-booth-2026-62',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Amy Flowers',
    email: 'amybflowers@gmail.com',
    company: 'Apalachee River Animal Hospital',
    role: 'Veterinarian',
    phone: '7062248057',
    city: 'Dacula',
    state: 'GA',
    country: 'United States Minor Outlying Islands',
    postalCode: '30019',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T16:13:23',
  },
  {
    id: 'fetch-charlotte-booth-2026-63',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kathy Frye',
    email: 'knfrye8@gmail.com',
    company: 'Viewmont Animal Hospital',
    role: 'Veterinarian',
    phone: '706-255-1819',
    city: 'Hickory',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28601',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T16:32:18',
  },
  {
    id: 'fetch-charlotte-booth-2026-64',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Ashley Fleshman',
    email: 'a.fleshmandvm@gmail.com',
    company: 'Bethlehem animal hospital',
    role: 'Veterinarian',
    phone: '3078802496',
    city: 'Hickory',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28602',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T17:09:12',
  },
  {
    id: 'fetch-charlotte-booth-2026-65',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Lisa Pachie',
    email: 'lahofmann@earthlink.net',
    company: 'Bridger Animal Hospital',
    role: 'Veterinarian',
    phone: '307-880-0556',
    city: 'Thayne',
    state: 'Wyoming',
    country: 'United States of America',
    postalCode: '83127',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T17:09:20',
  },
  {
    id: 'fetch-charlotte-booth-2026-66',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Sean Greenlaw',
    email: 'seano.verdes@gmail.com',
    company: 'Verdigris Pet Hospital and Emergency Care',
    role: 'Veterinarian',
    phone: '6035123093',
    city: 'New Bern',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28562',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T17:24:25',
  },
  {
    id: 'fetch-charlotte-booth-2026-67',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kylie Fackrell',
    email: 'info@mrahonline.com',
    company: 'Monroe Road Animal Hospital',
    role: 'Veterinarian',
    phone: '9802298905',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28205',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T17:44:15',
  },
  {
    id: 'fetch-charlotte-booth-2026-68',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Magda Sobanski',
    email: 'magdasobanski@hotmail.com',
    company: 'Monroe Road Animal Hospital',
    role: 'Veterinary Technician',
    phone: '7048073609',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28205',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T17:44:23',
  },
  {
    id: 'fetch-charlotte-booth-2026-69',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Jennifer Awbrey',
    email: 'jenn.awbrey@gmail.com',
    company: 'North Meck Animal Hospital',
    role: '',
    phone: '9806436977',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '29720',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T17:49:57',
  },
  {
    id: 'fetch-charlotte-booth-2026-70',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Amanda Munoz',
    email: 'amandamunoz.dvm@gmail.com',
    company: 'LBC Vets',
    role: 'Veterinarian',
    phone: '6617137826',
    city: 'Long Beach',
    state: 'California',
    country: 'United States of America',
    postalCode: '90815',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-13T17:50:02',
  },
  {
    id: 'fetch-charlotte-booth-2026-71',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Erika Mastalerz',
    email: 'efmdvm@gmail.com',
    company: 'Relief Work',
    role: 'Veterinarian',
    phone: '4433406462',
    city: 'Hickory',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28602',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T08:14:57',
  },
  {
    id: 'fetch-charlotte-booth-2026-72',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Faith Bumgarner',
    email: 'ftuckey@me.com',
    company: 'Vale Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '989-573-0542',
    city: 'Newton',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28658',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T08:15:01',
  },
  {
    id: 'fetch-charlotte-booth-2026-73',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Anna Rahn',
    email: 'rahn.anna@gmail.com',
    company: 'Relief Veterinarian',
    role: 'Veterinarian',
    phone: '414-305-9099',
    city: 'Cambridge',
    state: 'Massachusetts',
    country: 'United States of America',
    postalCode: '02140',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T08:18:01',
  },
  {
    id: 'fetch-charlotte-booth-2026-74',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kimberly Grill',
    email: 'kim.grill@gmail.com',
    company: 'Bond Vet',
    role: 'Veterinary Technician',
    phone: '4106299453',
    city: 'Matthews',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28104',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T08:24:46',
  },
  {
    id: 'fetch-charlotte-booth-2026-75',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Michelle Hoffman',
    email: 'hoffmandvm@greatneckvet.com',
    company: 'Great Neck Veterinary Care',
    role: 'Veterinarian',
    phone: '7577056302',
    city: 'Virginia Beach',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '23451',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T08:34:39',
  },
  {
    id: 'fetch-charlotte-booth-2026-76',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'BETHANY WYKES',
    email: 'drbethanywykes@gmail.com',
    company: 'Countryside Veterinary Services',
    role: 'Veterinarian',
    phone: '5176170501',
    city: 'Litchfield',
    state: 'Michigan',
    country: 'United States of America',
    postalCode: '49252',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T08:47:37',
  },
  {
    id: 'fetch-charlotte-booth-2026-77',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Sharon Jolley',
    email: 'sjolley@fosteranimalhospital.com',
    company: 'Foster Animal Hospital',
    role: 'Veterinary Technician',
    phone: '9806215020',
    city: 'Concord',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28025',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T08:59:30',
  },
  {
    id: 'fetch-charlotte-booth-2026-78',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Tina Henderson',
    email: 'twhend@icloud.com',
    company: 'Foster Animal Hospital',
    role: 'Veterinary Technician',
    phone: '704-305-4845',
    city: 'Concord',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28025',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T08:59:37',
  },
  {
    id: 'fetch-charlotte-booth-2026-79',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Deana Marta',
    email: 'dmarta@agapemobilevet.com',
    company: 'Agape Mobile Vet',
    role: 'Veterinarian',
    phone: '8456290999',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28278',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T09:05:41',
  },
  {
    id: 'fetch-charlotte-booth-2026-80',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'McKenna Thompson',
    email: 'mckennathompsondvm@gmail.com',
    company: 'North Iredell Animal Hospital',
    role: 'Owner',
    phone: '9282665235',
    city: 'Troutman',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28166',
    ticketType: 'Owner/Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T09:20:16',
  },
  {
    id: 'fetch-charlotte-booth-2026-81',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Angela Tuckerman',
    email: 'angelatuckerman@gmail.com',
    company: 'Indevets',
    role: 'Veterinarian',
    phone: '6144774697',
    city: 'Bedford',
    state: 'New Hampshire',
    country: 'United States of America',
    postalCode: '03110',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:08:06',
  },
  {
    id: 'fetch-charlotte-booth-2026-82',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Melissa Irvin',
    email: 'mirvinlyss@gmail.com',
    company: 'Whole Pet Mountain Island',
    role: 'Veterinarian',
    phone: '7049687338',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:14:02',
  },
  {
    id: 'fetch-charlotte-booth-2026-83',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Terra Berardi',
    email: 'drtaberardi@gmail.com',
    company: 'Hambright Animal Hospital',
    role: 'Veterinarian',
    phone: '5106857174',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28216',
    ticketType: 'GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:14:07',
  },
  {
    id: 'fetch-charlotte-booth-2026-84',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kevin Samson',
    email: 'samson.m.kevin@gmail.com',
    company: 'Temperance Animal Hospital',
    role: 'Veterinarian',
    phone: '4193515651',
    city: 'Toledo',
    state: 'Ohio',
    country: 'United States of America',
    postalCode: '43613',
    ticketType: 'GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:17:30',
  },
  {
    id: 'fetch-charlotte-booth-2026-85',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Ashley Beard',
    email: 'arbeard529@gmail.com',
    company: 'Sage Veterinary Center',
    role: 'Veterinarian',
    phone: '7327133715',
    city: 'JERSEY CITY',
    state: 'New Jersey',
    country: 'United States of America',
    postalCode: '07302',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:25:42',
  },
  {
    id: 'fetch-charlotte-booth-2026-86',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kira Purdon',
    email: 'kirapurdon@gmail.com',
    company: 'Sage Veterinary Center',
    role: 'Veterinarian',
    phone: '3524836441',
    city: 'JERSEY CITY',
    state: 'New Jersey',
    country: 'United States of America',
    postalCode: '07302',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:25:46',
  },
  {
    id: 'fetch-charlotte-booth-2026-87',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Justin Hoffman',
    email: 'hofjus96@gmail.com',
    company: 'Harleysville Veterinary Hospital',
    role: 'Veterinarian',
    phone: '2676156755',
    city: 'Lansdale',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '19446',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:29:27',
  },
  {
    id: 'fetch-charlotte-booth-2026-88',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Sheila Hanby',
    email: 'sbh@capesideah.com',
    company: 'Capeside Animal Hospital',
    role: 'Veterinarian',
    phone: '9104310120',
    city: 'WILMINGTON',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28411',
    ticketType: 'Owner/Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:35:45',
  },
  {
    id: 'fetch-charlotte-booth-2026-89',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Rhonda Greene',
    email: 'rhondagreene@bellsouth.net',
    company: 'Capeside Animal Hospital',
    role: 'Veterinarian',
    phone: '9192648849',
    city: 'Belville',
    state: 'NC',
    country: '',
    postalCode: '28451',
    ticketType: 'GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:35:49',
  },
  {
    id: 'fetch-charlotte-booth-2026-90',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Barbara Booth',
    email: 'bjblloyd@gmail.com',
    company: 'Foothills Animal Clinic',
    role: 'Veterinarian',
    phone: '7044765387',
    city: 'Forest City',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28043',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:42:54',
  },
  {
    id: 'fetch-charlotte-booth-2026-91',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kayley Peters',
    email: 'kayleyp@gmail.com',
    company: 'Healing Paws Veterinary Hospital',
    role: 'Veterinarian',
    phone: '9192607448',
    city: 'Efland',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27243',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:43:00',
  },
  {
    id: 'fetch-charlotte-booth-2026-92',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Sara Barnes',
    email: 'sarabarnesdvm@gmail.com',
    company: 'Banfield',
    role: 'Veterinarian',
    phone: '7609637397',
    city: 'Victorville',
    state: 'California',
    country: 'United States of America',
    postalCode: '92395',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:43:22',
  },
  {
    id: 'fetch-charlotte-booth-2026-93',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Smitha Srinath',
    email: 'ssmitha811@gmail.com',
    company: 'VCA',
    role: 'Veterinarian',
    phone: '5627551485',
    city: 'Buena park',
    state: 'California',
    country: 'United States of America',
    postalCode: '90621',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:43:26',
  },
  {
    id: 'fetch-charlotte-booth-2026-94',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Katy Miller',
    email: 'katynaborsdvm@gmail.com',
    company: 'Animal Care Center of Tupelo',
    role: 'Veterinarian',
    phone: '6628710044',
    city: 'Tupelo',
    state: 'Mississippi',
    country: 'United States of America',
    postalCode: '38801',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T10:43:33',
  },
  {
    id: 'fetch-charlotte-booth-2026-95',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Amber Carpenter',
    email: 'acarpenter@vanguardvh.org',
    company: 'Vanguard Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '910-420-2902',
    city: 'West End',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27376',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T11:47:47',
  },
  {
    id: 'fetch-charlotte-booth-2026-96',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Rebecca Stiert',
    email: 'rjstiert@gmail.com',
    company: 'IndeVets',
    role: 'Veterinarian',
    phone: '8457060288',
    city: 'Woonsocket',
    state: 'Rhode Island',
    country: 'United States of America',
    postalCode: '02895',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T11:56:06',
  },
  {
    id: 'fetch-charlotte-booth-2026-97',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Dana Vamvakias',
    email: 'dvamvakias@vanguardvh.org',
    company: 'Vanguard Veterinary Hospital',
    role: 'Owner',
    phone: '9105852130',
    city: 'West End',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27376',
    ticketType: 'Owner/Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T12:19:41',
  },
  {
    id: 'fetch-charlotte-booth-2026-98',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Rachel Foor-Gray',
    email: 'rachel.b.foor@gmail.com',
    company: 'Waverly Animal Clinic',
    role: 'Veterinarian',
    phone: '9312098145',
    city: 'McEwen',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37101',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T12:24:32',
  },
  {
    id: 'fetch-charlotte-booth-2026-99',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Ashton Wise',
    email: 'ashtonwiseahs@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T12:27:50',
  },
  {
    id: 'fetch-charlotte-booth-2026-100',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Emily Cornett',
    email: 'emilycornettahs@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T12:27:53',
  },
  {
    id: 'fetch-charlotte-booth-2026-101',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Meredith Teague',
    email: 'meredith.teague@nva.com',
    company: 'Foothills Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '8643820039',
    city: 'Greenville',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29617-7326',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T12:33:28',
  },
  {
    id: 'fetch-charlotte-booth-2026-102',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Lorraine Maresca',
    email: 'lorraine.maresca@gmail.com',
    company: '2601',
    role: 'Veterinary Technician',
    phone: '8435041213',
    city: 'Simpsonville',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29681',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T12:33:32',
  },
  {
    id: 'fetch-charlotte-booth-2026-103',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Barbars Stastny',
    email: 'barbopvc@aol.com',
    company: 'Opossum Pike Veterinary Clinic',
    role: 'Owner',
    phone: '3016399120',
    city: 'Frederick',
    state: 'Maryland',
    country: 'United States of America',
    postalCode: '21702',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T12:43:55',
  },
  {
    id: 'fetch-charlotte-booth-2026-104',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Margaret Zarouba',
    email: 'docnyodie@aol.com',
    company: 'Solomons Veterinary Medical Center',
    role: 'Veterinarian',
    phone: '5858310961',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-14T12:44:20',
  },
  {
    id: 'fetch-charlotte-booth-2026-105',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Dejanae Young',
    email: 'ddoeyoung19@gmail.com',
    company: 'Twin Creek Animal Hospital',
    role: 'Veterinary Technician',
    phone: '4027095760',
    city: 'Omaha',
    state: 'Nebraska',
    country: 'United States of America',
    postalCode: '68106',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:01:56',
  },
  {
    id: 'fetch-charlotte-booth-2026-106',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Gianna Covelli',
    email: 'drgcovelli@gmail.com',
    company: 'Evette staffing-relief veterinarian',
    role: 'Veterinarian',
    phone: '8102892096',
    city: 'Columbia',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29229',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:02:03',
  },
  {
    id: 'fetch-charlotte-booth-2026-107',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Grace Schoenecke',
    email: 'drschoenecke@lunsfordvet.com',
    company: 'Lunsford Veterinary Care Center',
    role: 'Veterinarian',
    phone: '785-614-0474',
    city: 'Siloam Springs',
    state: 'Arkansas',
    country: 'United States of America',
    postalCode: '72761',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:02:10',
  },
  {
    id: 'fetch-charlotte-booth-2026-108',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Mary Rizzolo',
    email: '02-vectors.zinger@icloud.com',
    company: 'Northwest Animal Hospital',
    role: 'Veterinarian',
    phone: '4403828741',
    city: 'Trinity',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27370',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:02:17',
  },
  {
    id: 'fetch-charlotte-booth-2026-109',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kathy Fioretti',
    email: 'katherinefioretti@yahoo.com',
    company: 'Banfield',
    role: 'Veterinarian',
    phone: '5413577527',
    city: 'Eugene',
    state: 'Oregon',
    country: 'United States of America',
    postalCode: '97402',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:02:23',
  },
  {
    id: 'fetch-charlotte-booth-2026-110',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Bailey Debbs',
    email: 'baileydebbs@gmail.com',
    company: 'Petfolk',
    role: 'Veterinarian',
    phone: '856-745-1060',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28203',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:02:28',
  },
  {
    id: 'fetch-charlotte-booth-2026-111',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Alison Jensen',
    email: 'alidvm@aol.com',
    company: 'N/a',
    role: 'Veterinarian',
    phone: '5095280414',
    city: 'Atoka',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '38004',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:02:34',
  },
  {
    id: 'fetch-charlotte-booth-2026-112',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Summer Sullivan',
    email: 'ssullivan@elpasoanimalurgentcare.com',
    company: 'Veterinary Innovative Partners',
    role: 'Practice Manager',
    phone: '9158730676',
    city: 'EL PASO',
    state: 'Texas',
    country: 'United States of America',
    postalCode: '79912',
    ticketType: 'Practice Manager',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:02:39',
  },
  {
    id: 'fetch-charlotte-booth-2026-113',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Summer Sullivan',
    email: 'ssullivan@elpasoanimalurgentcare.com',
    company: 'Veterinary Innovative Partners',
    role: 'Practice Manager',
    phone: '9158730676',
    city: 'EL PASO',
    state: 'Texas',
    country: 'United States of America',
    postalCode: '79912',
    ticketType: 'Practice Manager',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:02:44',
  },
  {
    id: 'fetch-charlotte-booth-2026-114',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Dana Cress',
    email: 'dcress@carolinavet.com',
    company: 'Carolina Veterinary Specialists',
    role: 'Hospital Staff',
    phone: '804-621-8815',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28226',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:03:06',
  },
  {
    id: 'fetch-charlotte-booth-2026-115',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Savannah Rhyne',
    email: 'msrhynervt@gmail.com',
    company: 'Carolina Veterinary Specialists',
    role: 'Veterinary Technician',
    phone: '8284613239',
    city: 'Huntersville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28078',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:03:14',
  },
  {
    id: 'fetch-charlotte-booth-2026-116',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Savannah Rhyne',
    email: 'msrhynervt@gmail.com',
    company: 'Carolina Veterinary Specialists',
    role: 'Veterinary Technician',
    phone: '8284613239',
    city: 'Huntersville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28078',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:03:22',
  },
  {
    id: 'fetch-charlotte-booth-2026-117',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Robin Parker',
    email: 'rparker@carolinavet.com',
    company: 'Carolina Veterinary Specialists',
    role: 'Veterinary Technician',
    phone: '6312417701',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:03:30',
  },
  {
    id: 'fetch-charlotte-booth-2026-118',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Timothy Hayes',
    email: 'timothyhayes82@gmail.com',
    company: 'Pet Health Of Hampstead',
    role: 'Veterinary Technician',
    phone: '7086997142',
    city: 'Burgaw',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28425',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:03:35',
  },
  {
    id: 'fetch-charlotte-booth-2026-119',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Brielle Marinelli',
    email: 'vetbrielle@gmail.com',
    company: 'Community Animal Hospital',
    role: 'Veterinary Technician',
    phone: '9734051535',
    city: 'Lake Hiawatha',
    state: 'New Jersey',
    country: 'United States of America',
    postalCode: '07034',
    ticketType: 'Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:03:40',
  },
  {
    id: 'fetch-charlotte-booth-2026-120',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Mia Birtles',
    email: 'miaalfieri@gmail.com',
    company: 'River Oaks Animal Hospital',
    role: 'Veterinary Technician',
    phone: '6103085319',
    city: 'Myrtle Beach',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29579',
    ticketType: 'Hospital Staff',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:03:47',
  },
  {
    id: 'fetch-charlotte-booth-2026-121',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kendall Cope',
    email: 'kcope1599@gmail.com',
    company: 'Kings Mountain Animal Clinic',
    role: 'Veterinarian',
    phone: '2767343585',
    city: 'Martinsville',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '24112',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:03:51',
  },
  {
    id: 'fetch-charlotte-booth-2026-122',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Ian McHarg',
    email: 'ian@sagepethospital.com',
    company: 'Sage Pet Hospital',
    role: 'Practice Manager',
    phone: '8285678012',
    city: 'Hendersonville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28791',
    ticketType: 'Practice Manager',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:03:56',
  },
  {
    id: 'fetch-charlotte-booth-2026-123',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kenneth Gallatin',
    email: 'kensmail101@gmail.com',
    company: 'Mission Pet Health (Riverside Veterinary Hospital)',
    role: 'Veterinarian',
    phone: '9105275933',
    city: 'Rocky Mount',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27804',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:04:00',
  },
  {
    id: 'fetch-charlotte-booth-2026-124',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Heather Peeler',
    email: 'hepeeler@gmail.com',
    company: 'BluePearl South Charlotte',
    role: 'Hospital Staff',
    phone: '7042395817',
    city: 'Salisbury',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28144',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:04:04',
  },
  {
    id: 'fetch-charlotte-booth-2026-125',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Jennifer Huang',
    email: 'jennifer.huang.dvm@gmail.com',
    company: 'CARE',
    role: 'Veterinarian',
    phone: '7049298364',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28211',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:04:09',
  },
  {
    id: 'fetch-charlotte-booth-2026-126',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Brooke Weinstein',
    email: 'b.weinstein.313@gmail.com',
    company: 'Orange County Emergency Pet Clinic',
    role: 'Veterinarian',
    phone: '9496779237',
    city: 'tustin',
    state: 'California',
    country: 'United States of America',
    postalCode: '92782',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:04:14',
  },
  {
    id: 'fetch-charlotte-booth-2026-127',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kara Beebe',
    email: 'allaboutthatbark@gmail.com',
    company: 'Veterinary Hospital at the Lake',
    role: 'Student',
    phone: '8284466104',
    city: 'Sherrills Ford',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28673',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:04:18',
  },
  {
    id: 'fetch-charlotte-booth-2026-128',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Megan Sweet',
    email: 'msweetdvm@gmail.com',
    company: 'Veterinary Hospital at the Lake',
    role: 'Veterinarian',
    phone: '2487608314',
    city: 'Sherrills Ford',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28673',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:04:55',
  },
  {
    id: 'fetch-charlotte-booth-2026-129',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Stacey Manczka-Fisher',
    email: 'copperdogvet@gmail.com',
    company: '',
    role: 'Veterinarian',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:05:07',
  },
  {
    id: 'fetch-charlotte-booth-2026-130',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Stacey Manczka-Fisher',
    email: 'copperdogvet@gmail.com',
    company: '',
    role: 'Veterinarian',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:05:12',
  },
  {
    id: 'fetch-charlotte-booth-2026-131',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Jessica Anderson',
    email: 'dogtoranderson@gmail.com',
    company: 'East Lincoln Animal Hospital',
    role: 'Veterinarian',
    phone: '7179195561',
    city: 'charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28214',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:05:19',
  },
  {
    id: 'fetch-charlotte-booth-2026-132',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Suzanne Barnes',
    email: 'suzannebarnesdvm@gmail.com',
    company: 'Spay Neuter Clinic of the Carolinas',
    role: 'Veterinarian',
    phone: '8594960754',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28277',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:05:23',
  },
  {
    id: 'fetch-charlotte-booth-2026-133',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Kendra Ewalt',
    email: 'dockendra@gmail.com',
    company: 'Hometown Veterinary Partners LLC',
    role: 'Veterinarian',
    phone: '8594730071',
    city: 'Carlisle',
    state: 'Kentucky',
    country: 'United States of America',
    postalCode: '40311',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:05:28',
  },
  {
    id: 'fetch-charlotte-booth-2026-134',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Giselle Boertjens',
    email: 'giselleboertjens@dvm.com',
    company: 'Banfield Pet Hospital',
    role: 'Veterinarian',
    phone: '8144426604',
    city: 'Somerset',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '15501',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:05:33',
  },
  {
    id: 'fetch-charlotte-booth-2026-135',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Jennifer Friend',
    email: 'jennifer.friend@cvpco.com',
    company: 'Onslow Animal Hospital',
    role: 'Veterinarian',
    phone: '7244607614',
    city: 'Jacksonville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28540',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:05:38',
  },
  {
    id: 'fetch-charlotte-booth-2026-136',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Raylene Hinely-Schroeck',
    email: 'rayvet12@msn.com',
    company: 'Erie Animal Hospital',
    role: 'Veterinarian',
    phone: '8143920712',
    city: 'Erie',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '16506',
    ticketType: 'GP Opthalmologist Workshop',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:05:46',
  },
  {
    id: 'fetch-charlotte-booth-2026-137',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Patricia Cioccio',
    email: 'patticioccio.cvt@gmail.com',
    company: 'Professional Veterinary Technician Services of NWPA',
    role: 'Veterinary Technician',
    phone: '8144800702',
    city: 'Erie',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '16511',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:06:14',
  },
  {
    id: 'fetch-charlotte-booth-2026-138',
    eventKey: 'fetch-charlotte-booth-2026',
    eventName: 'Fetch Charlotte 2026 Booth',
    sourceFile: 'Fetch Charlotte 展位.xlsx',
    fullName: 'Elysa Braunstein',
    email: 'elysavmd@gmail.com',
    company: 'McGrath Veterinary Center',
    role: 'Veterinarian',
    phone: '6613135595',
    city: 'Sherman Oaks',
    state: 'California',
    country: 'United States of America',
    postalCode: '91403',
    ticketType: 'Veterinarian',
    context: 'G4EYNUNKYC',
    notes: '',
    scannedAt: '2026-03-15T13:06:30',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-1',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'GAGAN GUPTA',
    email: 'gagan1947@yahoo.com',
    company: 'BANFIELD PET HOSPITAL',
    role: 'Veterinarian',
    phone: '8140000000',
    city: 'TAMPA',
    state: 'Florida',
    country: 'United States of America',
    postalCode: '33635',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-2',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Tyana Brown',
    email: 'tyanabrown@gmail.com',
    company: 'Indevets',
    role: 'Veterinarian',
    phone: '2670000000',
    city: 'Philadelphia',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '19153',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-3',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Lucia DeChurch',
    email: 'lmdechurch715@gmail.com',
    company: 'Poland Veterinary Centre',
    role: 'Veterinarian',
    phone: '3310000000',
    city: 'Canfield',
    state: 'Ohio',
    country: 'United States of America',
    postalCode: '44406',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-4',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'James Schinner Jr',
    email: 'jschinnerdvm@comcast.net',
    company: 'IndeVets',
    role: 'Veterinarian',
    phone: '3020000000',
    city: 'Ijamsville',
    state: 'Maryland',
    country: '',
    postalCode: '21754',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-5',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Angela Tuckerman',
    email: 'angelatuckerman@gmail.com',
    company: 'Indevets',
    role: 'Veterinarian',
    phone: '6140000000',
    city: 'Bedford',
    state: 'New Hampshire',
    country: 'United States of America',
    postalCode: '3110',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-6',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Matthew Ottoson',
    email: 'macaotto@gmail.com',
    company: 'Fanwood Animal Hospital',
    role: '',
    phone: '908-868-2013',
    city: 'Fanwood',
    state: 'New Jersey',
    country: 'United States of America',
    postalCode: '7023',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-7',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Lauren Holden',
    email: 'lholden@nwindhamvet.com',
    company: 'North Windham Veterinary Hospital',
    role: 'Veterinarian',
    phone: '6040000000',
    city: 'Harrison',
    state: 'Maine',
    country: 'United States of America',
    postalCode: '4040',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-8',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Linda McCloskey',
    email: 'lsmccloskey@aloha-vet.com',
    company: 'Aloha Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '7030000000',
    city: 'Mooresville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28117',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-9',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Audrey Germane',
    email: 'agermane@gmail.com',
    company: 'Hanover Green Vet Clinic',
    role: 'Veterinarian',
    phone: '8050000000',
    city: 'Ashland',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '23005',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-10',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Melissa Schlader',
    email: 'mschlader@hotmail.com',
    company: 'West Fargo Animal Hospital',
    role: 'Veterinarian',
    phone: '5160000000',
    city: 'West Fargo',
    state: 'North Dakota',
    country: 'United States of America',
    postalCode: '58078',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-11',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Giselle Boertjens',
    email: 'giselleboertjens@dvm.com',
    company: 'Banfield Pet Hospital',
    role: 'Veterinarian',
    phone: '8140000000',
    city: 'Somerset',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '15501',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-12',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Sara Barnes',
    email: 'sarabarnesdvm@gmail.com',
    company: 'Banfield',
    role: 'Veterinarian',
    phone: '7610000000',
    city: 'Victorville',
    state: 'California',
    country: 'United States of America',
    postalCode: '92395',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-13',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Casey Gates',
    email: 'casey.m.gates23@gmail.com',
    company: 'All For Paws Animal Clinic',
    role: 'Veterinarian',
    phone: '7040000000',
    city: 'Blacksburg',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '24060',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-14',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Ashleigh Storms',
    email: 'biology.wilson7@gmail.com',
    company: 'Aloha Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '4710000000',
    city: 'Mooresville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28117',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-15',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Jessica Anderson',
    email: 'dogtoranderson@gmail.com',
    company: 'East Lincoln Animal Hospital',
    role: '',
    phone: '7180000000',
    city: 'charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28214',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-16',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Melissa Maxwell',
    email: 'maxwellvmd@gmail.com',
    company: 'Holly Ridge Veterinary Hospital',
    role: 'Veterinarian',
    phone: '724-910-5900',
    city: 'Holly Ridge',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28445',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-17',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kylie Fackrell',
    email: 'info@mrahonline.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-18',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Michelle Greenberg',
    email: 'msgreenberg29@gmail.com',
    company: '9100000000',
    role: 'Veterinarian',
    phone: '7150000000',
    city: 'Yorba Linda',
    state: 'California',
    country: 'United States of America',
    postalCode: '92887',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-19',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Meagan Kizer',
    email: 'meaganstar101@gmail.com',
    company: 'Orangeburg Veterinary Associates',
    role: 'Veterinarian',
    phone: '8440000000',
    city: 'Orangeburg',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29118',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-20',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'John Daugherty',
    email: 'dogdoctor@aol.com',
    company: 'VIN',
    role: 'Veterinarian',
    phone: '3310000000',
    city: 'Concord',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28027',
    ticketType: 'Military/Retired Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-21',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Ashley Beard',
    email: 'arbeard529@gmail.com',
    company: 'Sage Veterinary Center',
    role: 'Veterinarian',
    phone: '7330000000',
    city: 'JERSEY CITY',
    state: 'New Jersey',
    country: 'United States of America',
    postalCode: '7302',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-22',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Mariah Calhoun, RVT',
    email: 'mariah.calhoun@svp.vet',
    company: 'Carmel Road Animal Hospital',
    role: 'Practice Manager',
    phone: '3150000000',
    city: 'Monroe',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28112',
    ticketType: 'Practice Manager',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-23',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Audrey Ditty',
    email: 'audreyditty@gmail.com',
    company: 'Concord Veterinary Hospital',
    role: '',
    phone: '5130000000',
    city: 'Farragut',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37934',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-24',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kara Stem',
    email: 'karastemdvm@gmail.com',
    company: 'Boulevard Animal Hospital',
    role: 'Veterinarian',
    phone: '8440000000',
    city: 'Athens',
    state: 'Georgia',
    country: 'United States of America',
    postalCode: '30601',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-25',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Courtney Chapin',
    email: 'hartcourtney01@gmail.com',
    company: 'Fort Plain Animal Hospital',
    role: 'Veterinary Technician',
    phone: '315-868-2268',
    city: 'Newport',
    state: 'New York',
    country: 'United States of America',
    postalCode: '13416',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-26',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Melana Martens',
    email: 'melanab@yahoo.com',
    company: 'East Maryland Animal Hospital NVA',
    role: 'Veterinarian',
    phone: '6020000000',
    city: 'Phoenix',
    state: 'Arizona',
    country: 'United States of America',
    postalCode: '85012',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-27',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Ceilidh Knudson',
    email: 'cknudsondvm@gmail.com',
    company: 'Humane Society of Charlotte',
    role: 'Veterinarian',
    phone: '4440000000',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28208',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-28',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Carmen Dobroth',
    email: 'cdobroth@gmail.com',
    company: 'River City Veterinary Hospital',
    role: 'Veterinarian',
    phone: '208-860-4178',
    city: 'Nampa',
    state: 'Idaho',
    country: 'United States of America',
    postalCode: '83687',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-29',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Catherine Sabino',
    email: 'catherine.sabino@rbvh.net',
    company: 'Red Bank Veterinary Hospital',
    role: 'Veterinarian',
    phone: '732-337-0378',
    city: 'Red Bank',
    state: 'New Jersey',
    country: 'United States of America',
    postalCode: '07701-6775',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-30',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kelly Naughton',
    email: 'kmerch92@gmail.com',
    company: 'Lap of Love',
    role: 'Veterinarian',
    phone: '7040000000',
    city: 'Alexandria',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '22302',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-31',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Nicole Hein',
    email: 'nhein@unionlakepets.com',
    company: 'Union Lake Veterinary Hospital',
    role: '',
    phone: '734-925-2015',
    city: 'Waterford Twp',
    state: 'Michigan',
    country: 'United States of America',
    postalCode: '48327',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-32',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Robin Parker',
    email: 'rparker@carolinavet.com',
    company: 'Carolina Veterinary Specialists',
    role: '',
    phone: '6310000000',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-33',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Patricia Cioccio',
    email: 'patticioccio.cvt@gmail.com',
    company: 'Professional Veterinary Technician Services of NWPA',
    role: '',
    phone: '8140000000',
    city: 'Erie',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '16511',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-34',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Stacey Manczka',
    email: 'copperdogvet@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-35',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Katie Baeyens',
    email: 'kbaeyensdvm@gmail.com',
    company: 'Baeyens Hauk Veterinary Group',
    role: 'Veterinarian',
    phone: '5020000000',
    city: 'Little Rock',
    state: 'Arkansas',
    country: 'United States of America',
    postalCode: '72210',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-36',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Shelley Lander',
    email: 'rvtlander@gmail.com',
    company: 'C.A.R.E.',
    role: 'Veterinary Technician',
    phone: '7050000000',
    city: 'Gastonia',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28054',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-37',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Ellis Burner',
    email: 'ellisburner@gmail.com',
    company: 'Four Paws Animal Clinic',
    role: 'Veterinarian',
    phone: '8430000000',
    city: 'Columbia',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29205',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-38',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Anna Rahn',
    email: 'rahn.anna@gmail.com',
    company: 'Relief Veterinarian',
    role: 'Veterinarian',
    phone: '414-305-9099',
    city: 'Cambridge',
    state: 'Massachusetts',
    country: 'United States of America',
    postalCode: '2140',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-39',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Katrina Yasin',
    email: 'klcarroll8@gmail.com',
    company: 'Baxter Veterinary Clinic',
    role: '',
    phone: '8030000000',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-40',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kaitlyn Mogck',
    email: 'kaitzimmer@outlook.com',
    company: 'Casselton Vet Service',
    role: 'Veterinary Technician',
    phone: '2190000000',
    city: 'Casselton',
    state: 'North Dakota',
    country: 'United States of America',
    postalCode: '58012',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-41',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Roxann Nelson',
    email: '88rox@cox.net',
    company: 'Middle Plantation Animal Hospital',
    role: 'Veterinary Technician',
    phone: '7580000000',
    city: 'Toano',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '23168',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-42',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Grace Schoenecke',
    email: 'drschoenecke@lunsfordvet.com',
    company: 'Lunsford Veterinary Care Center',
    role: 'Veterinarian',
    phone: '785-614-0474',
    city: 'Siloam Springs',
    state: 'Arkansas',
    country: 'United States of America',
    postalCode: '72761',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-43',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Amy Gates',
    email: 'gates.vet@gmail.com',
    company: 'Brookline Animal Hospital',
    role: '',
    phone: '6030000000',
    city: 'Brookline',
    state: 'New Hampshire',
    country: 'United States of America',
    postalCode: '3033',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-44',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Leslie Odom',
    email: 'leslie.odom@svp.vet',
    company: 'Mission Pet Health',
    role: 'Veterinarian',
    phone: '8650000000',
    city: 'Johnson City',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37604',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-45',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kaitlin Greer',
    email: 'kaitlinagreer@gmail.com',
    company: 'Simpsonville Animal Hospital',
    role: 'Veterinarian',
    phone: '9550000000',
    city: 'Greenville',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29607',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-46',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kristine Laabs-Cogdill',
    email: 'kris.cogdill@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-47',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Danielle Storozynsky',
    email: 'danielles@vt.edu',
    company: 'Hanover Green Veterinary Clinic',
    role: 'Veterinarian',
    phone: '7580000000',
    city: 'Richmond',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '23221',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-48',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Ashley Fleshman',
    email: 'a.fleshmandvm@gmail.com',
    company: 'Bethlehem animal hospital',
    role: 'Veterinarian',
    phone: '3080000000',
    city: 'Hickory',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28602',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-49',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kristin Oâ€™Callaghan',
    email: 'kristinocall@gmail.com',
    company: 'Relief',
    role: '',
    phone: '2250000000',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-50',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'GARRY MILLER',
    email: 'garry.d.miller55@gmail.com',
    company: 'Animalife Mission Hills',
    role: 'Veterinarian',
    phone: '8160000000',
    city: 'naples',
    state: 'Florida',
    country: 'United States of America',
    postalCode: '34114',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-51',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Molly Simpson',
    email: 'msimpson@unionlakepets.com',
    company: 'Union Lake Veterinary Hospital',
    role: '',
    phone: '2490000000',
    city: 'Waterford',
    state: 'Michigan',
    country: 'United States of America',
    postalCode: '48327',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-52',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Melissa Irvin',
    email: 'mirvinlyss@gmail.com',
    company: 'Whole Pet Mountain Island',
    role: '',
    phone: '7050000000',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-53',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Johanna Smith',
    email: 'joeyc27@hotmail.com',
    company: 'Hendersonville Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '7050000000',
    city: 'Inman',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29349',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-54',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Janelle Brown',
    email: 'janrae0596@gmail.com',
    company: 'Bridgemill Animal Hospital',
    role: '',
    phone: '7040000000',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28277',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-55',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Terra Berardi',
    email: 'drtaberardi@gmail.com',
    company: 'Hambright Animal Hospital',
    role: '',
    phone: '5110000000',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28216',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-56',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'sandrina simonovich',
    email: 'sandrinasimonovich1629@gmail.com',
    company: 'Central Veterinary Hospital',
    role: '',
    phone: '9740000000',
    city: 'Knoxville',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37924',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-57',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Jennifer Friend',
    email: 'jennifer.friend@cvpco.com',
    company: 'Onslow Animal Hospital',
    role: 'Veterinarian',
    phone: '7240000000',
    city: 'Jacksonville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28540',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-58',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kalie Hopkins',
    email: 'kehop@bellsouth.net',
    company: 'Simpsonville Animal Hospital',
    role: '',
    phone: '8650000000',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-59',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Andrew Milian',
    email: 'miliandvm@gmail.com',
    company: 'Commonwealth Animal Hospital',
    role: 'Veterinarian',
    phone: '8130000000',
    city: 'Harrisburg',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28075-9627',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-60',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Linda Perry',
    email: 'perrybikepalace@bellsouth.net',
    company: 'Wallburg Animal Care Relief',
    role: '',
    phone: '3360000000',
    city: 'Winston Salem',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27107',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-61',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Sean Greenlaw',
    email: 'seano.verdes@gmail.com',
    company: 'Verdigris Pet Hospital and Emergency Care',
    role: '',
    phone: '6040000000',
    city: 'New Bern',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28562',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-62',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Bailey Debbs',
    email: 'baileydebbs@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-63',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Lewis Radicke',
    email: 'lradicke1@gmail.com',
    company: 'Lincoln Heights Animal Hospital',
    role: 'Owner',
    phone: '2100000000',
    city: 'San Antonio',
    state: 'Texas',
    country: 'United States of America',
    postalCode: '78209',
    ticketType: 'Owner/Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-64',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kenneth Kingston',
    email: 'kenneth.kingston@nva.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-65',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kelsey Rowe',
    email: 'kelsey.vonier.rowe@gmail.com',
    company: 'Kelsey Rowe Veterinary Services LLC',
    role: '',
    phone: '8050000000',
    city: 'Fort Mill',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29715',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-66',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Douglas Graham',
    email: 'douglasgrahamdvm@gmail.com',
    company: 'Heidt Veterinary Hospital',
    role: 'Veterinarian',
    phone: '5410000000',
    city: 'Columbus',
    state: 'Ohio',
    country: 'United States of America',
    postalCode: '43235',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-67',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Maria Salazar',
    email: 'spicedvm@yahoo.com',
    company: 'Express Vets',
    role: 'Veterinarian',
    phone: '9550000000',
    city: 'Canton',
    state: 'Georgia',
    country: 'United States of America',
    postalCode: '30114',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-68',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'THERESA BROWNING',
    email: 'catdoc92@aol.com',
    company: 'Cherryville animal hospital',
    role: 'Veterinarian',
    phone: '7050000000',
    city: 'Kings Mountain',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28086',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-69',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Richard Morgan',
    email: 'rikoshay53@aol.com',
    company: 'Retired',
    role: 'Veterinarian',
    phone: '805-350-3820',
    city: 'Sequim',
    state: 'Washington',
    country: 'United States of America',
    postalCode: '98382',
    ticketType: 'Military/Retired Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-70',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Rachael Nelson-Smith',
    email: 'rlnelsonsmith@gmail.com',
    company: 'Fort Washington Vet',
    role: 'Veterinarian',
    phone: '6100000000',
    city: 'Ambler',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '19002',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-71',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kayley Peters',
    email: 'kayleyp@gmail.com',
    company: 'Healing Paws Veterinary Hospital',
    role: 'Veterinarian',
    phone: '9190000000',
    city: 'Efland',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27243',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-72',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kristi Sharpe',
    email: 'dr.kristisharpe@gmail.com',
    company: 'Rocky Hill Animal Hospital',
    role: 'Veterinarian',
    phone: '4230000000',
    city: 'Knoxville',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37919',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-73',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Nancy Stieber',
    email: 'nstieber@yahoo.com',
    company: 'Banfield',
    role: 'Veterinarian',
    phone: '6120000000',
    city: 'Bloomington',
    state: 'Minnesota',
    country: 'United States of America',
    postalCode: '55438',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-74',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: "Sarah D'Amelio",
    email: 'snshishdvm@gmail.com',
    company: 'South Point Pet Hospital',
    role: '',
    phone: '7040000000',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-75',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Briana Montambault',
    email: 'brimontam@gmail.com',
    company: 'Wolcott Veterinary Clinic',
    role: 'Veterinarian',
    phone: '2040000000',
    city: 'Wolcott',
    state: 'Connecticut',
    country: 'United States of America',
    postalCode: '6716',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-76',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Roberta McFerren',
    email: 'robynmdvm@gmail.com',
    company: 'Self employed relief',
    role: 'Veterinarian',
    phone: '7050000000',
    city: 'Belmont',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28012',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-77',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Marnie Gallagher',
    email: 'milliecat44@gmail.com',
    company: 'Armstrong Animal Clinic',
    role: '',
    phone: '7050000000',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28205',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-78',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Sean Stewart',
    email: 'seanstewart@comporium.net',
    company: 'Palmetto Veterinary Medicine and Surgery',
    role: 'Veterinarian',
    phone: '8030000000',
    city: 'Rock Hill',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29730',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-79',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Martha McCoy',
    email: 'martha.mccoy@thrivepet.com',
    company: 'Four Paws Animal Clinic',
    role: 'Veterinarian',
    phone: '4240000000',
    city: 'Columbia',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29204',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-80',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Rachel Foor-Gray',
    email: 'rachel.b.foor@gmail.com',
    company: 'Waverly Animal Clinic',
    role: 'Veterinarian',
    phone: '9310000000',
    city: 'McEwen',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37101',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-81',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Chelsea DiGregorio',
    email: 'chelsea.digregoriodvm@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-82',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Eryn Zeugschmidt',
    email: 'drerynz@gmail.com',
    company: 'Aspen Creek Veterinary Hospital',
    role: 'Veterinarian',
    phone: '4250000000',
    city: 'Conifer',
    state: 'Colorado',
    country: 'United States of America',
    postalCode: '80433',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-83',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Sarah Carroll',
    email: 'dr.sarah.carroll@gmail.com',
    company: 'Carolina Pets Animal Hospital',
    role: '',
    phone: '9200000000',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-84',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Ali Baker',
    email: 'alissa.baker@nva.com',
    company: 'NVA',
    role: 'Veterinarian',
    phone: '4240000000',
    city: 'Swayzee',
    state: 'Indiana',
    country: 'United States of America',
    postalCode: '46986',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-85',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Richard Rafferty',
    email: 'drrafferty@circlecanimalhospital.com',
    company: 'Circle C Animal Hospital',
    role: 'Veterinarian',
    phone: '5120000000',
    city: 'Austin',
    state: 'TX',
    country: '',
    postalCode: '78749',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-86',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Dana Hogg',
    email: 'thebirdnerd15@gmail.com',
    company: 'Nash County Animal Hospital',
    role: 'Veterinarian',
    phone: '9200000000',
    city: 'Clayton',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27520',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-87',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Faye Oberg',
    email: 'mrs.fayemcnulty@gmail.com',
    company: 'Milford Animal Hospital/WVP',
    role: '',
    phone: '2040000000',
    city: 'Milford',
    state: 'Connecticut',
    country: 'United States of America',
    postalCode: '6460',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-88',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'LYNDA PAUL',
    email: 'lyndapaul@yahoo.com',
    company: 'NANUET ANIMAL HOSPITAL',
    role: 'Veterinary Technician',
    phone: '8450000000',
    city: 'Stony Point',
    state: 'New York',
    country: 'United States of America',
    postalCode: '10980',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-89',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Lisa Pachie',
    email: 'lahofmann@earthlink.net',
    company: 'Bridger Animal Hospital',
    role: 'Veterinarian',
    phone: '307-880-0556',
    city: 'Thayne',
    state: 'Wyoming',
    country: 'United States of America',
    postalCode: '83127',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-90',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Melissa Becker',
    email: 'mbeckerdvm@eastsidevetsav.com',
    company: 'Eastside Veterinary',
    role: 'Veterinarian',
    phone: '7060000000',
    city: 'Savannah',
    state: 'Georgia',
    country: 'United States of America',
    postalCode: '31404',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-91',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'BETHANY WYKES',
    email: 'drbethanywykes@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-92',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Allison O Connor',
    email: 'anoconnorhome2@gmail.com',
    company: 'Belmont Vet Center/Carevet',
    role: 'Veterinarian',
    phone: '4030000000',
    city: 'Lincoln',
    state: 'Nebraska',
    country: 'United States of America',
    postalCode: '68516',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-93',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kathy Fioretti',
    email: 'katherinefioretti@yahoo.com',
    company: 'Banfield',
    role: 'Veterinarian',
    phone: '5410000000',
    city: 'Eugene',
    state: 'Oregon',
    country: 'United States of America',
    postalCode: '97402',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-94',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Tom Lomax',
    email: 'logandvm13@msn.com',
    company: 'Fallston Veterinary Clinic',
    role: 'Veterinarian',
    phone: '4430000000',
    city: 'Bel Air',
    state: 'Maryland',
    country: 'United States of America',
    postalCode: '21015',
    ticketType: 'Owner/Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-95',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Alexa Diaz',
    email: 'drdiaz@queencityah.com',
    company: 'Queen City Animal Hospital',
    role: '',
    phone: '7860000000',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28205',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-96',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Jennifer Larson',
    email: 'jenswan11@gmail.com',
    company: 'Uptown Veterinary Hospital',
    role: '',
    phone: '7710000000',
    city: 'Matthews',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28105',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-97',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Savannah Rhyne',
    email: 'msrhynervt@gmail.com',
    company: 'Carolina Veterinary Specialists',
    role: 'Veterinary Technician',
    phone: '8280000000',
    city: 'Huntersville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28078',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-98',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Anna LaCalamito',
    email: 'caroline.beyer.hc@gmail.com',
    company: 'Banfield',
    role: 'Veterinarian',
    phone: '8280000000',
    city: 'Belmont',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28012-6771',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-99',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Sara Chamberlain',
    email: 'chamberlainse1995@gmail.com',
    company: 'Animal Care Center',
    role: 'Veterinarian',
    phone: '5700000000',
    city: 'Orangeville',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '17859',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-100',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: "Cecille O'Brien Greenleaf VMD",
    email: 'caogreenleaf@gmail.com',
    company: 'Veterinary HouseCalls',
    role: 'Veterinarian',
    phone: '6510000000',
    city: 'San jose',
    state: 'California',
    country: 'United States of America',
    postalCode: '95129',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-101',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Abigail Hockenberry',
    email: 'abigail.hiley@gmail.com',
    company: 'Piedmont Veterinary Clinic',
    role: 'Veterinarian',
    phone: '7050000000',
    city: 'Durham',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27713',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-102',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Alicia Precour',
    email: 'aliciaprecour32@gmail.com',
    company: 'Tacoma Animal Hospital',
    role: 'Veterinary Technician',
    phone: '360-918-1192',
    city: 'Tacoma',
    state: 'Washington',
    country: 'United States of America',
    postalCode: '98409',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-103',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Nicolette La Forge',
    email: 'nicolette.laforge@gmail.com',
    company: 'Royal Veterinary College',
    role: 'Student',
    phone: '448000000000',
    city: 'Potters bar',
    state: 'N/A',
    country: 'United Kingdom',
    postalCode: 'EN61HT',
    ticketType: 'Student',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-104',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'James Gross',
    email: 'jtgdvm@aol.com',
    company: 'Goodlettsville Animal Hospital',
    role: 'Veterinarian',
    phone: '6150000000',
    city: 'Hendersonville',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37075',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-105',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Connie Johnson',
    email: 'okieiscute12@yahoo.com',
    company: 'Petvet',
    role: 'Veterinary Technician',
    phone: '8050000000',
    city: 'Mooresville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28117',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-106',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kenneth Gallatin',
    email: 'kensmail101@gmail.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'The GP Opthalmologist Workshop',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-107',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Denise Thagard',
    email: 'theanimalbridge@yahoo.com',
    company: 'Christian Veterinary Mission',
    role: 'Veterinarian',
    phone: '9110000000',
    city: 'Fayetteville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28312',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-108',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Sara Talbot',
    email: 's_gumbiner@hotmail.com',
    company: 'Sedgefield Animal Hospital',
    role: 'Veterinarian',
    phone: '336-324-6060',
    city: 'Greensboro',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27455',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-109',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Rachel Goodall',
    email: 'rldgoodall@gmail.com',
    company: 'Relief Veterinarian',
    role: 'Veterinarian',
    phone: '7010000000',
    city: 'De Soto',
    state: 'Iowa',
    country: 'United States of America',
    postalCode: '50069',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-110',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Madison Alvey',
    email: 'madison.alvey@gmail.com',
    company: 'Good Dog Veterinary Care',
    role: 'Veterinarian',
    phone: '6780000000',
    city: 'Roswell',
    state: 'GA',
    country: '',
    postalCode: '30075',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-111',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Michelle Hoffman',
    email: 'hoffmandvm@greatneckvet.com',
    company: 'Great Neck Veterinary Care',
    role: 'Veterinarian',
    phone: '7580000000',
    city: 'Virginia Beach',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '23451',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-112',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Ross Larson',
    email: 'uptownvetinfo@gmail.com',
    company: 'Uptown Veterinary Hospital',
    role: '',
    phone: '7040000000',
    city: 'Matthews',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28105',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-113',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Elizabeth Cotton',
    email: 'lizcotton@pm.me',
    company: 'Fuquay Veterinary Hospital',
    role: 'Veterinarian',
    phone: '9200000000',
    city: 'Fuquay Varina',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27526',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-114',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Keri Craft',
    email: 'kcraft419@gmail.com',
    company: 'Hanging Rock Animal Hospital',
    role: '',
    phone: '5410000000',
    city: 'Roanoke',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '24018',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-115',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Stiert Rebecca',
    email: 'rjstiert@gmail.com',
    company: 'IndeVets',
    role: '',
    phone: '8460000000',
    city: 'Woonsocket',
    state: 'Rhode Island',
    country: 'United States of America',
    postalCode: '2895',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-116',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Robert browning',
    email: 'rebdvm123@gmail.com',
    company: 'Cherryville animal hospital',
    role: 'Veterinarian',
    phone: '7050000000',
    city: 'Cherryville',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28021',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-117',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kim Bergendorff',
    email: 'kdorfff@gmail.com',
    company: 'Smithtown animal hospital',
    role: 'Veterinarian',
    phone: '6320000000',
    city: 'Smithtown',
    state: 'NY',
    country: '',
    postalCode: '11722',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-118',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Dana Cress',
    email: 'dcress@carolinavet.com',
    company: 'Carolina Veterinary Specialists',
    role: '',
    phone: '804-621-8815',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28226',
    ticketType: 'Hospital Staff, Practice Manager, or Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-119',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'megan alexander',
    email: 'megan_alex88@hotmail.com',
    company: 'Seaford Veterinary Medical Center',
    role: 'Veterinarian',
    phone: '757-660-0373',
    city: 'Yorktown',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '23692',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-120',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Michael Fietz',
    email: 'drfietz@xroadsanimalhospital.com',
    company: 'Crossroads Animal Hospital',
    role: 'Veterinarian',
    phone: '4340000000',
    city: 'Charlottesville',
    state: 'Virginia',
    country: '',
    postalCode: '22902',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-121',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Cinthia Honeycutt',
    email: 'hrahdoc@yahoo.com',
    company: 'Hanging Rock Animal Hospital',
    role: '',
    phone: '540-562-4596',
    city: 'Roanoke',
    state: 'Virginia',
    country: 'United States of America',
    postalCode: '24019',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-122',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'David Gallagher',
    email: 'casavius1@att.net',
    company: 'Clear Creek Animal Hospital',
    role: '',
    phone: '7050000000',
    city: 'Charlotte',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28227',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-123',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kevin Garrison',
    email: 'kgarrison@vetcor.com',
    company: 'Vetcor',
    role: 'Veterinarian',
    phone: '919-710-7653',
    city: 'Spartanburg',
    state: 'South Carolina',
    country: 'United States of America',
    postalCode: '29302',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-124',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Lindsey Campo',
    email: 'campolinds@gmail.com',
    company: 'Heartland',
    role: 'Veterinarian',
    phone: '3310000000',
    city: 'Blountville',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37617',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-125',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Alison Jensen',
    email: 'alidvm@aol.com',
    company: 'N/a',
    role: '',
    phone: '5100000000',
    city: 'Atoka',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '38004',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-126',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Rebecca Theodorou',
    email: 'theodorourm@gmail.com',
    company: 'PetVet365 The Terminal',
    role: 'Veterinarian',
    phone: '973-454-5028',
    city: 'Pittsburgh',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '15212',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-127',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Rachel JOHNSON',
    email: 'rjohnson.cy@gmail.com',
    company: 'PETWELLCLINIC - PLUM',
    role: 'Veterinarian',
    phone: '9040000000',
    city: 'Monroeville',
    state: 'Pennsylvania',
    country: 'United States of America',
    postalCode: '15146',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-128',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Krysta Stewarts',
    email: 'stewartsdvm@gmail.com',
    company: 'Animal Medical Center',
    role: '',
    phone: '8470000000',
    city: 'Skokie',
    state: 'Illinois',
    country: 'United States of America',
    postalCode: '60077',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-129',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Kira Purdon',
    email: 'kirapurdon@gmail.com',
    company: 'Sage Veterinary Center',
    role: 'Veterinarian',
    phone: '3520000000',
    city: 'JERSEY CITY',
    state: 'New Jersey',
    country: 'United States of America',
    postalCode: '7302',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-130',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Andrea Paynter',
    email: 'blazerone81@yahoo.com',
    company: 'Rocky Hill Animal Hospital',
    role: 'Veterinarian',
    phone: '8180000000',
    city: 'Knoxville',
    state: 'Tennessee',
    country: 'United States of America',
    postalCode: '37919',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-131',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Madison Washington',
    email: 'madisonw2421@gmail.com',
    company: 'Boulevard Animal Hospital',
    role: 'Veterinarian',
    phone: '7720000000',
    city: 'Raleigh',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '27615',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-132',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Rinieh Temchin',
    email: 'arielatemchin@gmail.com',
    company: 'Paw Springs Veterinary Hospital',
    role: 'Veterinary Technician',
    phone: '3480000000',
    city: 'Wilmington',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28412',
    ticketType: 'Veterinary Technician',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-133',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Lindsay Romo',
    email: 'lindsay.romo@svp.vet',
    company: 'Mission Pet Health',
    role: 'Veterinarian',
    phone: '706-829-8118',
    city: 'Gastonia',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28056',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-134',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Carolyn Ives',
    email: 'gcives@gmail.com',
    company: 'Dry Pond Animal Hospital',
    role: '',
    phone: '9190000000',
    city: 'Stanley',
    state: 'North Carolina',
    country: 'United States of America',
    postalCode: '28164',
    ticketType: 'Veterinarian, Owner, or Partner',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-135',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Jessica Brissey',
    email: 'jlbrissey@yahoo.com',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Tibial Tuberosity Advancement. Introducing MMP',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
  {
    id: 'fetch-charlotte-ce-class-2026-136',
    eventKey: 'fetch-charlotte-ce-class-2026',
    eventName: 'Fetch Charlotte 2026 CE Class',
    sourceFile: 'Fetch Charlotte CE Class.xlsx',
    fullName: 'Beverly Creasy',
    email: 'zebagus@verizon.net',
    company: '',
    role: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    ticketType: 'Veterinarian',
    context: 'The Must-Know Deets on Canine Diabetes',
    notes: '',
    scannedAt: '',
  },
]
